// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Outfit:wght@400;500;600;700;800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Digiping floating coach chat — matches profiling chat look & feel */

/* Immersive mode (same contract as live training) — loaded with Digiping so it works without /live-training */
html.lt-immersive,
html.lt-immersive body {
  position: fixed;
  inset: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  overflow: hidden;
  overscroll-behavior: none;
  -webkit-overflow-scrolling: touch;
  touch-action: manipulation;
}

html.lt-immersive body {
  background: #0b0f19;
}

html.digiping-chat-open .bottom-nav,
html.lt-immersive.digiping-chat-open .bottom-nav {
  display: none !important;
  pointer-events: none;
}

html.digiping-chat-open .main-content-with-bottom-nav {
  padding-bottom: 0 !important;
}

.digiping-chat {
  --dp-bg: #0b0f19;
  --dp-slate: #0f172a;
  --dp-primary: var(--brand-primary, #0877bc);
  --dp-primary-dark: var(--brand-primary-dark, #065a8f);
  --dp-primary-light: var(--brand-primary-light, #0a8cd8);
  --dp-secondary: var(--brand-secondary, #46528b);
  --dp-primary-gradient: linear-gradient(135deg, var(--dp-primary) 0%, var(--dp-primary-dark) 100%);
  --dp-accent: var(--brand-primary-light, #0a8cd8);
  --dp-text: #f8fafc;
  --dp-muted: #94a3b8;
  --dp-glass: rgba(15, 23, 42, 0.92);
  --dp-border: rgba(255, 255, 255, 0.08);
  --wizard-accent: var(--dp-accent);
  --wizard-text-muted: #94a3b8;
  --wizard-text-main: #f8fafc;
  font-family: 'Outfit', 'Inter', -apple-system, sans-serif;
  color: var(--dp-text);
  box-sizing: border-box;
}

.digiping-chat *,
.digiping-chat *::before,
.digiping-chat *::after {
  box-sizing: border-box;
}

/* FAB */
.digiping-chat__fab {
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 1300;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  border: 2px solid color-mix(in srgb, var(--dp-accent) 45%, transparent);
  background: radial-gradient(
    circle at 30% 25%,
    color-mix(in srgb, var(--dp-accent) 35%, transparent),
    color-mix(in srgb, var(--dp-primary) 95%, transparent) 55%,
    var(--dp-primary-dark)
  );
  box-shadow:
    0 12px 32px color-mix(in srgb, var(--dp-primary) 45%, transparent),
    0 0 24px color-mix(in srgb, var(--dp-accent) 20%, transparent);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  transition: transform 0.25s cubic-bezier(0.25, 1, 0.5, 1), box-shadow 0.25s ease;
}

.digiping-chat__fab:hover {
  transform: scale(1.06);
  box-shadow:
    0 16px 40px color-mix(in srgb, var(--dp-primary) 55%, transparent),
    0 0 32px color-mix(in srgb, var(--dp-accent) 28%, transparent);
}

.digiping-chat__fab:active {
  transform: scale(0.97);
}

.digiping-chat__fab-dot {
  position: absolute;
  top: 6px;
  right: 6px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #ff4a5a;
  border: 2px solid #0b0f19;
}

@media (max-width: 600px) {
  .digiping-chat__fab {
    bottom: 96px;
  }
}

/* Full-viewport shell (live-training style) */
.digiping-chat__shell {
  position: fixed;
  top: var(--dp-vv-top, 0px);
  left: 0;
  right: 0;
  z-index: 1400;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  width: 100%;
  height: var(--dp-vvh, 100dvh);
  max-height: var(--dp-vvh, 100dvh);
  max-width: none;
  border: none;
  border-radius: 0;
  box-shadow: none;
  background-color: rgba(11, 15, 25, 0.55);
  background-image:
    radial-gradient(at 0% 0%, color-mix(in srgb, var(--dp-primary) 15%, transparent) 0px, transparent 50%),
    radial-gradient(at 100% 100%, color-mix(in srgb, var(--dp-accent) 8%, transparent) 0px, transparent 50%),
    linear-gradient(rgba(255, 255, 255, 0.01) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255, 255, 255, 0.01) 1px, transparent 1px);
  background-size: 100% 100%, 100% 100%, 30px 30px, 30px 30px;
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  padding: env(safe-area-inset-top) env(safe-area-inset-right) env(safe-area-inset-bottom)
    env(safe-area-inset-left);
  animation: digipingFadeIn 0.3s ease both;
}

.digiping-chat__shell--fullscreen {
  /* alias kept for markup compatibility */
}

.digiping-chat__shell--docked {
  top: auto;
  left: 0;
  right: 0;
  height: min(48dvh, 460px);
  max-height: 48dvh;
  background: transparent;
  background-image: none;
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
  padding: 0 0 env(safe-area-inset-bottom, 0px);
  z-index: 1350;
}

.digiping-chat__shell--docked .digiping-chat__panel {
  max-width: none;
  margin: 0;
  border-radius: 18px 18px 0 0;
  border: 1px solid var(--dp-border);
  box-shadow: 0 -16px 48px rgba(0, 0, 0, 0.35);
}

.digiping-chat__planning-chip {
  flex: 0 0 auto;
  margin: 0;
  padding: 6px 14px;
  font-size: 12px;
  font-weight: 650;
  letter-spacing: -0.01em;
  color: var(--dp-accent, #7dd3fc);
  background: color-mix(in srgb, var(--dp-primary, #0877bc) 16%, transparent);
  border-bottom: 1px solid var(--dp-border);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

@media (min-width: 900px) {
  .digiping-chat__shell--docked {
    top: 0;
    left: auto;
    /* Planning focus: wider reading column, still leaves board visible */
    width: min(640px, 52vw);
    height: var(--dp-vvh, 100dvh);
    max-height: var(--dp-vvh, 100dvh);
  }

  .digiping-chat__shell--docked .digiping-chat__panel {
    border-radius: 0;
    border-left: 1px solid var(--dp-border);
    box-shadow: -12px 0 40px rgba(0, 0, 0, 0.28);
  }
}

/* Planning mode: compact quick answers, more history, wider bubbles */
.digiping-chat__shell--planning .digiping-chat__profiling-tray {
  padding: 0.45rem 0.85rem 0.3rem;
  max-height: min(32vh, 240px);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.digiping-chat__shell--planning .digiping-chat__profiling-tray-title {
  margin: 0 0 0.4rem;
  font-size: 0.7rem;
  letter-spacing: 0.06em;
}

.digiping-chat__shell--planning .digiping-chat__profiling-options {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  gap: 0.35rem;
}

.digiping-chat__shell--planning .digiping-chat__profiling-option {
  flex: 0 0 auto;
  width: 100%;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  text-align: left;
  gap: 0.55rem;
  border-radius: 10px;
  padding: 0.45rem 0.7rem;
}

.digiping-chat__shell--planning .digiping-chat__profiling-option:hover:not(:disabled) {
  transform: none;
  box-shadow: none;
}

.digiping-chat__shell--planning .digiping-chat__profiling-option-title {
  font-size: 0.84rem;
  font-weight: 600;
  line-height: 1.3;
}

.digiping-chat__shell--planning .digiping-chat__profiling-option-desc {
  font-size: 0.75rem;
  line-height: 1.3;
  opacity: 0.78;
}

.digiping-chat__shell--planning .digiping-chat__quick {
  gap: 0.35rem;
  padding: 0.4rem 0.85rem 0.55rem;
}

.digiping-chat__shell--planning .digiping-chat__chip {
  padding: 0.35rem 0.65rem;
  font-size: 0.78rem;
}

.digiping-chat__shell--planning .digiping-chat__ai-bubble,
.digiping-chat__shell--planning .digiping-chat__user-bubble {
  max-width: min(100%, 36rem);
}

.digiping-chat__shell--planning .digiping-chat__history {
  padding-left: 0.85rem;
  padding-right: 0.85rem;
}

.digiping-chat__shell--planning .digiping-chat__msg-text {
  font-size: 0.92rem;
  line-height: 1.4;
}

@keyframes digipingFadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

html:fullscreen .digiping-chat__shell,
html:-webkit-full-screen .digiping-chat__shell {
  width: 100%;
  height: var(--dp-vvh, 100%);
  min-height: 0;
  max-height: var(--dp-vvh, 100%);
}

/* Keyboard open: shell fills only the visible area, so the composer stays above it. */
html.digiping-keyboard-open .digiping-chat__shell,
body.digiping-keyboard-open .digiping-chat__shell,
html.digiping-keyboard-open:fullscreen .digiping-chat__shell,
html:-webkit-full-screen.digiping-keyboard-open .digiping-chat__shell {
  top: var(--dp-vv-top, 0px);
  height: var(--dp-vvh, 100dvh);
  min-height: 0;
  max-height: var(--dp-vvh, 100dvh);
  padding-bottom: 0;
}

.digiping-chat__panel {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-height: 0;
  max-width: 760px;
  margin: 0 auto;
  overflow: hidden;
  background: var(--dp-glass);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-left: 1px solid var(--dp-border);
  border-right: 1px solid var(--dp-border);
}

@media (max-width: 760px) {
  .digiping-chat__panel {
    max-width: none;
    border-left: none;
    border-right: none;
  }
}

/* Header */
.digiping-chat__header {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 1rem 1.15rem 0.85rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  background: rgba(8, 15, 28, 0.55);
}

.digiping-chat__brand {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  min-width: 0;
  flex: 1 1 auto;
  overflow: hidden;
}

.digiping-chat__avatar {
  width: 38px;
  height: 38px;
  background: radial-gradient(
    circle at 30% 25%,
    color-mix(in srgb, var(--dp-accent) 28%, transparent),
    color-mix(in srgb, var(--dp-primary) 45%, transparent) 60%,
    var(--dp-primary-dark)
  );
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid color-mix(in srgb, var(--dp-accent) 35%, transparent);
  box-shadow: 0 4px 14px color-mix(in srgb, var(--dp-accent) 18%, transparent);
  flex-shrink: 0;
  overflow: hidden;
}

.digiping-chat__avatar--sm {
  width: 36px;
  height: 36px;
}

.digiping-chat__avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
  display: block;
}

.digiping-chat--embedded {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 0;
  z-index: auto;
}

.digiping-chat__panel--embedded {
  max-width: none;
  height: 100%;
  min-height: 0;
  border: none;
  background: transparent;
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
}

.digiping-tech-intro {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  flex: 1 1 auto;
  min-height: 0;
  padding: 0.65rem 0.85rem 0.85rem;
  overflow: hidden;
}

.digiping-tech-intro__card {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 640px;
  min-height: 0;
  max-height: 100%;
  flex: 1 1 auto;
  margin: 0 auto;
  background: rgba(15, 23, 42, 0.82);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 24px;
  padding: 1.15rem 1.2rem 1rem;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.45);
  overflow: hidden;
}

.digiping-tech-intro__header {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex: 0 0 auto;
  margin-bottom: 0.85rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  padding-bottom: 0.75rem;
}

.digiping-tech-intro__card .scforh-intro {
  margin: 0 0 0.75rem;
  flex: 0 0 auto;
}

.digiping-tech-intro__card .intro-body-text {
  flex: 0 0 auto;
  margin-bottom: 0.65rem;
}

.digiping-tech-intro__scroll .intro-body-text {
  margin-top: 0;
}

.digiping-tech-intro__scroll {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
  touch-action: pan-y;
  margin: 0.15rem 0 0.75rem;
  padding: 0.15rem 0.2rem 0.5rem;
  border-radius: 14px;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.22) transparent;
}

.digiping-tech-intro__scroll::-webkit-scrollbar {
  width: 6px;
}

.digiping-tech-intro__scroll::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 999px;
}

.digiping-tech-intro__card .who-capsule {
  margin: 0 0 0.85rem;
}

.digiping-tech-intro__card .digiping-scforh-expand {
  margin: 0.75rem 0 0;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: rgba(15, 23, 42, 0.35);
  overflow: hidden;
}

.digiping-tech-intro__card .digiping-scforh-expand > summary {
  list-style: none;
  cursor: pointer;
  padding: 0.7rem 0.9rem;
  font-size: 0.82rem;
  font-weight: 700;
  color: #f8fafc;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
}

.digiping-tech-intro__card .digiping-scforh-expand > summary::-webkit-details-marker {
  display: none;
}

.digiping-tech-intro__card .digiping-scforh-expand > summary::after {
  content: "▸";
  color: rgba(248, 250, 252, 0.65);
  font-size: 0.75rem;
  transition: transform 0.15s ease;
}

.digiping-tech-intro__card .digiping-scforh-expand[open] > summary::after {
  transform: rotate(90deg);
}

.digiping-tech-intro__card .digiping-scforh-expand .who-capsule {
  margin: 0;
  padding: 0 0.75rem 0.85rem;
}

.digiping-tech-intro__card .digiping-scforh-expand .who-capsule__eyebrow {
  display: none;
}

.digiping-tech-intro__card .smart-grid {
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
  margin: 0;
}

.digiping-tech-intro__card .smart-bullet {
  display: flex;
  align-items: flex-start;
  gap: 0.7rem;
  padding: 0.55rem 0.7rem;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.06);
}

.digiping-tech-intro__card .smart-letter {
  flex-shrink: 0;
  width: 1.75rem;
  height: 1.75rem;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  font-size: 0.85rem;
  color: #0b0f19;
}

.digiping-tech-intro__card .smart-bullet--s .smart-letter { background: linear-gradient(135deg, #22d3ee, #0891b2); }
.digiping-tech-intro__card .smart-bullet--m .smart-letter { background: linear-gradient(135deg, #34d399, #059669); }
.digiping-tech-intro__card .smart-bullet--a .smart-letter { background: linear-gradient(135deg, #fbbf24, #d97706); }
.digiping-tech-intro__card .smart-bullet--r .smart-letter { background: linear-gradient(135deg, #fb7185, #e11d48); }
.digiping-tech-intro__card .smart-bullet--t .smart-letter { background: linear-gradient(135deg, #a78bfa, #7c3aed); }

.digiping-tech-intro__card .smart-bullet-copy {
  display: flex;
  flex-direction: column;
  gap: 0.12rem;
  min-width: 0;
}

.digiping-tech-intro__card .smart-label {
  font-size: 0.86rem;
  font-weight: 700;
  color: #f1f5f9;
}

.digiping-tech-intro__card .smart-desc {
  font-size: 0.78rem;
  line-height: 1.4;
  color: #94a3b8;
}

.digiping-tech-intro__card .wizard-begin-btn {
  flex: 0 0 auto;
  margin-top: auto;
  width: 100%;
  border: none;
  border-radius: 12px;
  padding: 0.8rem 1rem;
  font-family: inherit;
  font-weight: 700;
  font-size: 0.95rem;
  color: #fff;
  background: var(--dp-primary-gradient, linear-gradient(135deg, #0877bc, #065a8f));
  cursor: pointer;
}

.digiping-chat__brand-text {
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
  min-width: 0;
  flex: 1 1 auto;
  overflow: hidden;
}

.digiping-chat__agent-label-row {
  display: flex;
  align-items: center;
  gap: 0.38rem;
  min-width: 0;
  max-width: 100%;
  flex-wrap: nowrap;
  white-space: nowrap;
  overflow: hidden;
}

.digiping-chat__agent-label-row .digiping-chat__title {
  flex-shrink: 0;
  max-width: none;
  margin: 0;
  white-space: nowrap;
  font-size: 0.95rem;
  font-weight: 700;
  color: #fff;
}

.digiping-chat__label {
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: var(--dp-accent);
  display: block;
  margin: 0;
}

.digiping-chat__title {
  font-size: 0.95rem;
  font-weight: 700;
  letter-spacing: 0.01em;
  color: rgba(255, 255, 255, 0.96);
  display: block;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: min(70vw, 22rem);
}

.digiping-chat__tag {
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--dp-accent);
  opacity: 0.85;
}

.digiping-chat__actions {
  display: flex;
  align-items: center;
  gap: 0.15rem;
  flex-shrink: 0;
  position: relative;
  z-index: 6;
}

.digiping-chat__actions .lang-shortcut--invite .lang-shortcut__btn {
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.14);
  color: #f8fafc;
}

.digiping-chat__actions .lang-shortcut--invite .lang-shortcut__btn:hover,
.digiping-chat__actions .lang-shortcut--invite .lang-shortcut__btn.is-open {
  background: color-mix(in srgb, var(--dp-primary, #0877bc) 45%, transparent);
  border-color: color-mix(in srgb, var(--dp-accent, #0a8cd8) 50%, transparent);
}

.digiping-chat__actions .lang-shortcut--invite .lang-shortcut__panel {
  right: 0;
  left: auto;
}

.digiping-chat__icon-btn {
  width: 34px;
  height: 34px;
  border: none;
  border-radius: 10px;
  background: transparent;
  color: rgba(255, 255, 255, 0.78);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease;
}

.digiping-chat__icon-btn:hover {
  background: rgba(255, 255, 255, 0.08);
  color: #fff;
}

.digiping-chat__close-btn {
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.14);
  color: #fff;
  margin-left: 0.25rem;
  flex-shrink: 0;
}

.digiping-chat__close-btn:hover {
  background: rgba(239, 68, 68, 0.24);
  border-color: rgba(239, 68, 68, 0.5);
  color: #fca5a5;
  transform: scale(1.05);
}

.digiping-chat__close-btn:active {
  transform: scale(0.96);
}

/* History */
.digiping-chat__history {
  flex: 1 1 auto;
  min-height: 0;
  padding: 1.5rem 1.5rem 1.25rem;
  overflow-y: auto;
  overscroll-behavior: contain;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.1) transparent;
}

.digiping-chat__history::-webkit-scrollbar {
  width: 6px;
}

.digiping-chat__history::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
}

/* Rows & bubbles */
.digiping-chat__ai-row {
  display: flex;
  align-items: flex-start;
  gap: 0.8rem;
  align-self: flex-start;
  max-width: 88%;
  animation: digipingMsgIn 0.45s ease both;
}

.digiping-chat__user-row {
  align-self: flex-end;
  max-width: 80%;
  animation: digipingMsgIn 0.45s ease both;
}

@keyframes digipingMsgIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}

.digiping-chat__ai-bubble {
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 4px 18px 18px 18px;
  padding: 0.95rem 1.15rem 1.05rem;
  position: relative;
  min-width: 0;
}

.digiping-chat__user-bubble {
  background: var(--dp-primary-gradient);
  border-radius: 18px 18px 4px 18px;
  padding: 1rem 1.25rem;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 8px 16px -4px color-mix(in srgb, var(--dp-primary) 30%, transparent);
}

.digiping-chat__coach-label-row {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  margin-bottom: 0.4rem;
}

.digiping-chat__msg-text {
  font-size: 1.02rem;
  line-height: 1.5;
  margin: 0;
  white-space: pre-wrap;
  color: var(--dp-text);
}

.digiping-chat__user-bubble .digiping-chat__msg-text {
  color: #fff;
  font-weight: 500;
}

.digiping-chat__user-answer-row {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.45rem;
}

.digiping-chat__edit-answer-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  margin: 0;
  padding: 0.2rem 0.55rem;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.28);
  background: rgba(0, 0, 0, 0.18);
  color: rgba(255, 255, 255, 0.92);
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease;
}

.digiping-chat__edit-answer-btn:hover {
  background: rgba(0, 0, 0, 0.32);
  border-color: rgba(255, 255, 255, 0.45);
}

.digiping-chat__profiling-editing-hint {
  margin: 0 0 0.65rem;
  text-align: center;
  font-size: 0.88rem;
  font-weight: 600;
  color: var(--dp-accent, #0877bc);
}

.digiping-chat__typewriter {
  min-height: 1.5em;
  margin: 0;
  white-space: pre-wrap;
  font-size: 0.98rem;
  line-height: 1.55;
  color: #e8eef7;
}

.digiping-chat .typewriter-caret {
  display: inline-block;
  width: 2px;
  height: 1.05em;
  margin-left: 2px;
  vertical-align: text-bottom;
  background: var(--dp-accent);
  border-radius: 1px;
  animation: digipingCaretBlink 0.85s step-end infinite;
  font-size: 0;
  color: transparent;
}

@keyframes digipingCaretBlink {
  0%, 100% { opacity: 1; }
  50% { opacity: 0; }
}

/* Rich text — clean sections, no leading colons */
.digiping-chat .dp-em {
  font-weight: 700;
}

.digiping-chat .dp-em--s,
.digiping-chat .dp-em--specific { color: #22d3ee; }
.digiping-chat .dp-em--m { color: #34d399; }
.digiping-chat .dp-em--a { color: #fbbf24; }
.digiping-chat .dp-em--r { color: #fb7185; }
.digiping-chat .dp-em--t { color: #a78bfa; }
.digiping-chat .dp-em--smart {
  background: linear-gradient(90deg, #22d3ee, #a78bfa);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}
.digiping-chat .dp-em--goal { color: #38bdf8; }
.digiping-chat .dp-em--default { color: var(--dp-accent); }

.digiping-chat .dp-rich-text {
  display: flex;
  flex-direction: column;
  gap: 0.55rem;
  font-size: 0.98rem;
  line-height: 1.55;
  color: #e8eef7;
  white-space: normal;
}

.digiping-chat .dp-rich-section {
  display: flex;
  flex-direction: column;
  gap: 0.28rem;
  padding-top: 0.15rem;
}

.digiping-chat .dp-rich-heading {
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  line-height: 1.35;
}

.digiping-chat .dp-rich-p {
  margin: 0;
  color: #e2e8f0;
}

.digiping-chat .dp-rich-smartline {
  margin: 0;
  padding: 0.45rem 0.65rem;
  border-radius: 10px;
  background: rgba(8, 15, 28, 0.45);
  border: 1px solid rgba(255, 255, 255, 0.06);
  font-size: 0.82rem;
  line-height: 1.45;
  color: #94a3b8;
}

.digiping-chat .dp-rich-ul,
.digiping-chat .dp-rich-ol {
  list-style: none;
  margin: 0.1rem 0 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.digiping-chat .dp-rich-ol--session-plan {
  gap: 0.55rem;
  margin: 0.35rem 0 0.55rem;
}

.digiping-chat .dp-rich-li {
  display: grid;
  grid-template-columns: 1.15rem 1fr;
  gap: 0.45rem;
  align-items: start;
}

.digiping-chat .dp-rich-li--exercise {
  grid-template-columns: 1.7rem 1fr;
  gap: 0.55rem;
  padding: 0.55rem 0.65rem;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.035);
  border: 1px solid rgba(255, 255, 255, 0.07);
}

.digiping-chat .dp-rich-dot {
  width: 0.38rem;
  height: 0.38rem;
  margin-top: 0.55em;
  border-radius: 50%;
  background: var(--dp-accent);
  box-shadow: 0 0 8px color-mix(in srgb, var(--dp-accent) 45%, transparent);
}

.digiping-chat .dp-rich-index {
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.04em;
  color: var(--dp-accent);
  margin-top: 0.12rem;
}

.digiping-chat .dp-rich-li--exercise .dp-rich-index {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.55rem;
  height: 1.55rem;
  margin-top: 0;
  border-radius: 999px;
  font-size: 0.78rem;
  background: color-mix(in srgb, var(--dp-accent, #0a8cd8) 18%, transparent);
  border: 1px solid color-mix(in srgb, var(--dp-accent, #0a8cd8) 42%, transparent);
}

.digiping-chat .dp-rich-li-copy {
  min-width: 0;
}

.digiping-chat .dp-rich-li-copy--exercise {
  display: flex;
  flex-direction: column;
  gap: 0.18rem;
}

.digiping-chat .dp-rich-ex-title {
  display: block;
  font-size: 0.95rem;
  font-weight: 650;
  line-height: 1.35;
  color: #f8fafc;
}

.digiping-chat .dp-rich-ex-meta {
  display: block;
  font-size: 0.78rem;
  line-height: 1.35;
  color: rgba(226, 232, 240, 0.72);
}

.digiping-chat .dp-rich-ex-note,
.digiping-chat .dp-rich-line--sub {
  display: block;
  font-size: 0.8rem;
  line-height: 1.35;
  color: rgba(148, 163, 184, 0.95);
}

.digiping-chat .dp-rich-line {
  display: block;
}

/* Typing */
.digiping-chat__typing {
  display: flex;
  align-items: flex-start;
  gap: 0.8rem;
  align-self: flex-start;
  max-width: 88%;
}

.digiping-chat__typing-dots {
  display: flex;
  align-items: center;
  gap: 4px;
  height: 20px;
  margin-top: 0.15rem;
}

.digiping-chat__typing-dots span {
  width: 8px;
  height: 8px;
  background: var(--dp-muted);
  border-radius: 50%;
  display: inline-block;
  animation: digipingBounceDot 1.4s infinite ease-in-out both;
}

.digiping-chat__typing-dots span:nth-child(1) { animation-delay: -0.32s; }
.digiping-chat__typing-dots span:nth-child(2) { animation-delay: -0.16s; }

@keyframes digipingBounceDot {
  0%, 80%, 100% { transform: scale(0); }
  40% { transform: scale(1); }
}

/* Quick actions */
.digiping-chat__quick {
  flex: 0 0 auto;
  display: flex;
  flex-wrap: wrap;
  gap: 0.55rem;
  justify-content: flex-start;
  padding: 0.65rem 1.15rem 0.85rem;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  background: rgba(10, 15, 28, 0.72);
  animation: digipingSlideUp 0.4s cubic-bezier(0.34, 1.56, 0.64, 1) both;
}

.digiping-chat__profiling-tray {
  flex: 0 0 auto;
  padding: 0.85rem 1.15rem 0.45rem;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  background: rgba(10, 15, 28, 0.72);
}

.digiping-chat__profiling-tray-title {
  margin: 0 0 0.7rem;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--dp-accent, #0a8cd8);
}

.digiping-chat__handoff-hint {
  margin: 0 0 0.75rem;
  font-size: 0.88rem;
  line-height: 1.45;
  color: rgba(255, 255, 255, 0.72);
}

.digiping-chat__handoff-cta {
  flex: 1 1 100%;
  border-color: color-mix(in srgb, var(--dp-accent, #0a8cd8) 45%, transparent);
  background: color-mix(in srgb, var(--dp-accent, #0a8cd8) 16%, transparent);
}

.digiping-chat__profiling-options {
  display: flex;
  flex-wrap: wrap;
  gap: 0.65rem;
}

.digiping-chat__profiling-option {
  flex: 1 1 150px;
  min-width: 0;
  max-width: 100%;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 16px;
  padding: 1rem 0.95rem;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
  transition: all 0.25s cubic-bezier(0.25, 1, 0.5, 1);
  color: var(--dp-text, #f8fafc);
  font-family: inherit;
  text-align: center;
}

.digiping-chat__profiling-option:hover:not(:disabled) {
  background: rgba(8, 119, 188, 0.06);
  border-color: rgba(8, 119, 188, 0.4);
  transform: translateY(-3px);
  box-shadow: 0 10px 20px -5px rgba(0, 0, 0, 0.4);
}

.digiping-chat__profiling-option:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.digiping-chat__profiling-option-title {
  font-size: 0.95rem;
  font-weight: 600;
  line-height: 1.35;
}

@keyframes digipingSlideUp {
  from { opacity: 0; transform: translateY(14px); }
  to { opacity: 1; transform: translateY(0); }
}

.digiping-chat__chip {
  appearance: none;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.04);
  color: var(--dp-text);
  font-family: inherit;
  font-size: 0.78rem;
  font-weight: 600;
  letter-spacing: 0.01em;
  padding: 0.45rem 0.75rem;
  border-radius: 999px;
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease, transform 0.15s ease;
}

.digiping-chat__chip:hover {
  background: color-mix(in srgb, var(--dp-primary) 22%, transparent);
  border-color: color-mix(in srgb, var(--dp-accent) 35%, transparent);
  transform: translateY(-1px);
}

.digiping-chat__chip:active {
  transform: scale(0.98);
}

/* Composer */
.digiping-chat__footer {
  flex: 0 0 auto;
  position: relative;
  z-index: 2;
  padding: 0.85rem 1.15rem 1.1rem;
  background: rgba(10, 15, 28, 0.92);
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 -12px 28px rgba(0, 0, 0, 0.35);
}

.digiping-chat__fixcode-hint {
  margin: 0 0 0.45rem;
  font-size: 0.75rem;
  letter-spacing: 0.04em;
  color: #d7fff8;
  background: rgba(10, 143, 138, 0.28);
  border: 1px solid rgba(167, 243, 232, 0.35);
  border-radius: 999px;
  padding: 0.28rem 0.7rem;
  width: fit-content;
}

.digiping-chat__composer {
  display: flex;
  align-items: flex-end;
  gap: 0.65rem;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 14px;
  padding: 0.45rem 0.55rem 0.45rem 0.9rem;
  scroll-margin-bottom: 1.25rem;
}

.digiping-chat__input {
  flex: 1 1;
  min-width: 0;
  background: transparent;
  border: none;
  outline: none;
  resize: none;
  color: var(--dp-text);
  font-family: inherit;
  /* 16px keeps iOS from zooming the page and shoving the field off-screen. */
  font-size: 16px;
  line-height: 1.45;
  min-height: calc(1.45em + 0.9rem);
  max-height: 50vh;
  max-height: 50dvh;
  overflow-x: hidden;
  overflow-y: hidden;
  padding: 0.45rem 0;
  transition: height 0.18s ease;
  /* Prefer scrolling inside the field once it hits half-screen. */
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
}

.digiping-chat__input--multiline {
  overflow-y: auto;
  padding-right: 0.15rem;
}

/* Long draft: text uses the full row, like a sent bubble. Mic and send sit underneath. */
.digiping-chat__composer:has(.digiping-chat__input--multiline) {
  flex-wrap: wrap;
  align-items: flex-end;
  padding: 1rem 1.25rem 0.45rem;
  gap: 0.45rem 0.65rem;
}

.digiping-chat__composer:has(.digiping-chat__input--multiline) .digiping-chat__input {
  order: -1;
  flex: 1 0 100%;
  width: 100%;
  padding: 0;
}

.digiping-chat__composer:has(.digiping-chat__input--multiline) .digiping-chat__voice {
  margin-left: auto;
}

.digiping-chat__input::placeholder {
  color: var(--dp-muted);
  opacity: 1;
}

.digiping-chat__send {
  width: 38px;
  height: 38px;
  border: none;
  border-radius: 10px;
  background: var(--dp-primary-gradient);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
  transition: transform 0.3s cubic-bezier(0.16, 1, 0.3, 1), opacity 0.2s ease;
}

.digiping-chat__attach {
  width: 38px;
  height: 38px;
  border: none;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.06);
  color: var(--dp-muted);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
  transform: rotate(-25deg);
  transition: transform 0.3s cubic-bezier(0.16, 1, 0.3, 1), background 0.2s ease, color 0.2s ease;
}

.digiping-chat__attach:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.12);
  color: var(--dp-text);
}

.digiping-chat__attach:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.digiping-chat__send:hover:not(:disabled) {
  transform: scale(1.05);
  filter: brightness(1.08);
}

.digiping-chat__send:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.digiping-chat__voice {
  flex-shrink: 0;
  display: flex;
  align-items: center;
}

@media (max-width: 640px) {
  .digiping-chat__ai-row,
  .digiping-chat__user-row {
    max-width: 94%;
  }

  .digiping-chat__msg-text,
  .digiping-chat .dp-rich-text {
    font-size: 0.95rem;
  }

  .digiping-chat__history {
    padding: 1rem 1rem 0.85rem;
  }
}
/* Digiping SMART progress rail */
.digiping-smart-rail {
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
}

.digiping-smart-rail__track {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0;
  padding-bottom: 0.65rem;
}

.digiping-smart-rail__link {
  flex: 1 1;
  height: 2px;
  margin: 0 0.2rem;
  border-radius: 2px;
  background: rgba(255, 255, 255, 0.08);
  transition: background 0.3s ease;
}

.digiping-smart-rail__link--complete,
.digiping-smart-rail__link--partial {
  background: linear-gradient(
    90deg,
    color-mix(in srgb, var(--dp-secondary) 55%, transparent),
    color-mix(in srgb, var(--dp-accent) 35%, transparent)
  );
}

.digiping-smart-rail__node {
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  border: 1.5px solid rgba(255, 255, 255, 0.12);
  background: rgba(15, 23, 42, 0.9);
  color: var(--wizard-text-muted);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  cursor: default;
  flex-shrink: 0;
  transition: transform 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease, background 0.25s ease;
}

.digiping-smart-rail__node:disabled {
  opacity: 1;
}

.digiping-smart-rail__node:not(:disabled) {
  cursor: pointer;
}

.digiping-smart-rail__letter {
  font-size: 0.75rem;
  font-weight: 800;
  letter-spacing: 0.02em;
}

.digiping-smart-rail__node.is-empty {
  opacity: 0.55;
}

.digiping-smart-rail__node.is-partial {
  animation: digipingPulse 1.6s ease-in-out infinite;
}

.digiping-smart-rail__node.is-complete {
  color: #0b0f19;
  border-color: transparent;
}

.digiping-smart-rail__node--s.is-complete { background: linear-gradient(135deg, #22d3ee, #0891b2); }
.digiping-smart-rail__node--m.is-complete { background: linear-gradient(135deg, #34d399, #059669); }
.digiping-smart-rail__node--a.is-complete { background: linear-gradient(135deg, #fbbf24, #d97706); }
.digiping-smart-rail__node--r.is-complete { background: linear-gradient(135deg, #fb7185, #e11d48); }
.digiping-smart-rail__node--t.is-complete { background: linear-gradient(135deg, #a78bfa, #7c3aed); }

.digiping-smart-rail__node.is-active {
  opacity: 1;
  z-index: 2;
  transform: scale(1.18);
  outline: 2px solid currentColor;
  outline-offset: 3px;
  box-shadow:
    0 0 0 4px color-mix(in srgb, var(--dp-accent) 35%, transparent),
    0 10px 24px color-mix(in srgb, var(--dp-accent) 28%, transparent);
  border-color: currentColor;
}

.digiping-smart-rail__node--s.is-active {
  color: #0891b2;
  box-shadow: 0 0 0 4px color-mix(in srgb, #22d3ee 45%, transparent), 0 10px 24px color-mix(in srgb, #22d3ee 32%, transparent);
}
.digiping-smart-rail__node--m.is-active {
  color: #059669;
  box-shadow: 0 0 0 4px color-mix(in srgb, #34d399 45%, transparent), 0 10px 24px color-mix(in srgb, #34d399 32%, transparent);
}
.digiping-smart-rail__node--a.is-active {
  color: #d97706;
  box-shadow: 0 0 0 4px color-mix(in srgb, #fbbf24 45%, transparent), 0 10px 24px color-mix(in srgb, #fbbf24 32%, transparent);
}
.digiping-smart-rail__node--r.is-active {
  color: #e11d48;
  box-shadow: 0 0 0 4px color-mix(in srgb, #fb7185 45%, transparent), 0 10px 24px color-mix(in srgb, #fb7185 32%, transparent);
}
.digiping-smart-rail__node--t.is-active {
  color: #7c3aed;
  box-shadow: 0 0 0 4px color-mix(in srgb, #a78bfa 45%, transparent), 0 10px 24px color-mix(in srgb, #a78bfa 32%, transparent);
}

.digiping-smart-rail__node.is-active.is-complete {
  color: #0b0f19;
  outline-color: rgba(255, 255, 255, 0.85);
}

.digiping-chat__composer--idle {
  align-items: center;
}

.digiping-chat__composer-idle {
  flex: 1 1;
  min-width: 0;
  background: transparent;
  border: none;
  outline: none;
  color: var(--dp-muted, #94a3b8);
  font-family: inherit;
  font-size: 1.02rem;
  line-height: 1.45;
  text-align: left;
  padding: 0.45rem 0;
  cursor: text;
}

.digiping-smart-rail__node.is-coach-pending {
  position: relative;
  border-color: rgba(251, 191, 36, 0.75);
}

.digiping-smart-rail__node.is-coach-pending.is-active {
  box-shadow:
    0 0 0 3px rgba(251, 191, 36, 0.55),
    0 0 18px rgba(251, 191, 36, 0.35);
  border-color: rgba(251, 191, 36, 0.95);
  transform: scale(1.12);
}

.digiping-smart-rail__coach {
  position: absolute;
  bottom: -0.55rem;
  left: 50%;
  transform: translateX(-50%);
  font-size: 0.5rem;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  white-space: nowrap;
  padding: 0.1rem 0.28rem;
  border-radius: 4px;
  background: rgba(251, 191, 36, 0.95);
  color: #1a1408;
  line-height: 1.1;
}

.digiping-smart-rail__caption {
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  text-align: center;
}

.digiping-coach-banner {
  margin: 0.35rem 0 0.85rem;
  padding: 0.65rem 0.8rem;
  border-radius: 10px;
  background: rgba(251, 191, 36, 0.12);
  border: 1px solid rgba(251, 191, 36, 0.35);
  color: var(--wizard-text-muted);
  font-size: 0.88rem;
  line-height: 1.4;
}


.digiping-coach-pill {
  display: inline-block;
  margin-left: 0.4rem;
  padding: 0.08rem 0.35rem;
  border-radius: 4px;
  font-size: 0.62rem;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  vertical-align: middle;
  background: rgba(251, 191, 36, 0.95);
  color: #1a1408;
}

@keyframes digipingPulse {
  0%, 100% { box-shadow: 0 0 0 0 color-mix(in srgb, var(--dp-accent) 0%, transparent); }
  50% { box-shadow: 0 0 0 6px color-mix(in srgb, var(--dp-accent) 12%, transparent); }
}

/* Digiping SMART rail / coach inbox extras */
.digiping-chat__smart-rail-wrap {
  flex: 0 0 auto;
  padding: 0.55rem 1.15rem 0.35rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  background: rgba(8, 15, 28, 0.4);
}

.digiping-chat__smart-summary {
  margin: 0 0 0.35rem;
  font-size: 0.8rem;
  color: var(--dp-muted, #94a3b8);
  line-height: 1.35;
}

.digiping-chat .dimension-chip {
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  padding: 0.15rem 0.5rem;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.08);
}

.digiping-chat__coach-inbox {
  flex: 0 0 auto;
  max-height: 32vh;
  overflow-y: auto;
  padding: 0.65rem 1.15rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  background: rgba(251, 191, 36, 0.06);
}

.digiping-chat__smart-roster {
  flex: 0 0 auto;
  max-height: 36vh;
  overflow-y: auto;
  padding: 0.65rem 1.15rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  background: rgba(56, 189, 248, 0.05);
}

.digiping-chat__smart-roster-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  margin-bottom: 0.35rem;
}

.digiping-chat__smart-roster-head .digiping-chat__coach-inbox-title {
  color: #7dd3fc;
  margin-bottom: 0;
}

.digiping-chat__smart-roster-loading {
  font-size: 0.75rem;
  color: #94a3b8;
}

.digiping-chat__smart-roster-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 0.3rem;
  margin-bottom: 0.45rem;
}

.digiping-chat__smart-roster-chip {
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: rgba(15, 23, 42, 0.45);
  color: #cbd5e1;
  border-radius: 999px;
  padding: 0.2rem 0.55rem;
  font-size: 0.7rem;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
}

.digiping-chat__smart-roster-chip.is-active {
  background: rgba(56, 189, 248, 0.2);
  border-color: rgba(125, 211, 252, 0.45);
  color: #e0f2fe;
}

.digiping-chat__smart-roster-list {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.digiping-chat__smart-roster-empty {
  margin: 0;
  font-size: 0.8rem;
  color: #94a3b8;
}

.digiping-chat__smart-roster-row {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr auto auto;
  align-items: center;
  gap: 0.45rem;
  text-align: left;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(15, 23, 42, 0.55);
  border-radius: 12px;
  padding: 0.5rem 0.6rem;
  color: inherit;
  cursor: pointer;
  font-family: inherit;
}

.digiping-chat__smart-roster-row.is-selected {
  border-color: rgba(125, 211, 252, 0.5);
  background: rgba(14, 165, 233, 0.12);
}

.digiping-chat__smart-roster-copy {
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
  min-width: 0;
  font-size: 0.78rem;
  color: #cbd5e1;
}

.digiping-chat__smart-roster-copy strong {
  font-size: 0.85rem;
  color: #f8fafc;
}

.digiping-chat__smart-roster-copy span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.digiping-chat__smart-roster-groups {
  color: #94a3b8 !important;
  font-size: 0.7rem !important;
}

.digiping-chat__smart-roster-progress {
  color: #7dd3fc !important;
  font-size: 0.72rem !important;
  font-weight: 600;
}

.digiping-chat__smart-roster-letters {
  display: flex;
  gap: 0.18rem;
  flex-shrink: 0;
}

.digiping-chat__smart-letter {
  width: 1.15rem;
  height: 1.15rem;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.62rem;
  font-weight: 800;
  background: rgba(255, 255, 255, 0.06);
  color: #64748b;
}

.digiping-chat__smart-letter--complete {
  background: rgba(34, 197, 94, 0.25);
  color: #86efac;
}

.digiping-chat__smart-letter--partial {
  background: rgba(251, 191, 36, 0.22);
  color: #fde68a;
}

.digiping-chat__smart-letter--empty {
  background: rgba(255, 255, 255, 0.05);
  color: #64748b;
}

.digiping-chat__smart-letter.is-pending {
  box-shadow: 0 0 0 1px rgba(251, 191, 36, 0.7);
}

.digiping-chat__smart-roster-badge {
  min-width: 1.25rem;
  height: 1.25rem;
  padding: 0 0.35rem;
  border-radius: 999px;
  background: rgba(251, 191, 36, 0.9);
  color: #0f172a;
  font-size: 0.7rem;
  font-weight: 800;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.digiping-chat__coach-inbox-title {
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #fbbf24;
  margin-bottom: 0.45rem;
}

.digiping-chat__coach-event {
  margin-bottom: 0.45rem;
}

.digiping-chat__coach-event-main {
  width: 100%;
  display: flex;
  align-items: flex-start;
  gap: 0.55rem;
  text-align: left;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(15, 23, 42, 0.55);
  border-radius: 12px;
  padding: 0.55rem 0.65rem;
  color: inherit;
  cursor: pointer;
  font-family: inherit;
}

.digiping-chat__coach-event-copy {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  min-width: 0;
  font-size: 0.82rem;
}

.digiping-chat__coach-event-copy strong {
  font-size: 0.85rem;
}

.digiping-chat__coach-review {
  margin-top: 0.4rem;
  padding: 0.55rem 0.65rem;
  border-radius: 12px;
  background: rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
}

.digiping-chat__coach-review p {
  margin: 0;
  font-size: 0.85rem;
  color: #cbd5e1;
}

.digiping-chat__coach-existing-note {
  color: #93c5fd !important;
  font-style: italic;
}

.digiping-chat__coach-review-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
}

.digiping-chat__coach-hint {
  margin: 0;
  font-size: 0.72rem;
  color: var(--dp-muted, #94a3b8);
}

.digiping-chat .animate-slide-up {
  animation: digipingSlideUp 0.4s cubic-bezier(0.34, 1.56, 0.64, 1) both;
}

.fb-msg--digiping .fb-msg__bubble {
  border: 1px solid color-mix(in srgb, var(--brand-primary-light, var(--dp-accent, #0a8cd8)) 35%, transparent);
  background: linear-gradient(
    135deg,
    color-mix(in srgb, var(--brand-primary, var(--dp-primary, #0877bc)) 18%, transparent),
    rgba(15, 23, 42, 0.9)
  );
}

.fb-msg__digiping-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  font-size: 0.68rem;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--brand-primary-light, var(--dp-accent, #0a8cd8));
  margin-bottom: 0.35rem;
}

.digiping-chat__people-pane {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.digiping-chat__main-tabs {
  flex-shrink: 0;
}

.digiping-chat__embedded-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  padding: 0.45rem 1rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  background: rgba(8, 15, 28, 0.35);
  flex-shrink: 0;
}

.digiping-chat__coach-suggest {
  margin: 0.5rem 0;
  padding: 0.65rem 0.75rem;
  border-radius: 12px;
  border: 1px solid color-mix(in srgb, var(--dp-accent, #0a8cd8) 40%, transparent);
  background: color-mix(in srgb, var(--dp-primary, #0877bc) 16%, transparent);
  font-size: 0.82rem;
  line-height: 1.4;
}

.digiping-chat__coach-suggest strong {
  display: block;
  margin-bottom: 0.25rem;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  font-size: 0.68rem;
  color: var(--dp-accent, #0a8cd8);
}

.digiping-chat__coach-suggest p {
  margin: 0 0 0.45rem;
  color: var(--dp-muted, #94a3b8);
}

.digiping-chat__coach-paths {
  list-style: none;
  margin: 0.35rem 0 0.55rem;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.digiping-chat__coach-paths li {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  padding: 0.4rem 0.5rem;
  border-radius: 10px;
  background: rgba(8, 15, 28, 0.35);
  border: 1px solid rgba(255, 255, 255, 0.06);
}

.digiping-chat__coach-paths span {
  font-size: 0.78rem;
  font-weight: 700;
  color: #e2e8f0;
}

.digiping-chat__coach-paths small {
  font-size: 0.72rem;
  line-height: 1.35;
  color: var(--dp-muted, #94a3b8);
}

.digiping-chat__path-axis {
  font-size: 0.62rem;
  font-style: normal;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--dp-accent, #0a8cd8);
}

/* Home Digiping people/agent tabs (same look as Live Training) */
.digiping-chat .dp-session-tabs {
  display: flex;
  gap: 6px;
  padding: 0.55rem 1rem 0.65rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  background: rgba(8, 15, 28, 0.4);
  flex-shrink: 0;
}

.digiping-chat .dp-session-tabs__tab {
  flex: 1 1;
  border: 1px solid transparent;
  border-radius: 999px;
  padding: 0.55rem 0.75rem;
  font-family: inherit;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--dp-muted, #94a3b8);
  background: rgba(255, 255, 255, 0.04);
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease, border-color 0.2s ease;
}

.digiping-chat .dp-session-tabs__tab--active {
  color: #fff;
  border-color: color-mix(in srgb, var(--dp-accent, #0a8cd8) 45%, transparent);
  background: color-mix(in srgb, var(--dp-primary, #0877bc) 28%, transparent);
}

/* AI Act Art. 50 notice — must stay legible on the dark Digiping chrome */
.digiping-chat__ai-notice {
  flex: 0 0 auto;
  margin: 0.5rem 1.15rem 0;
  background: rgba(255, 255, 255, 0.05);
  border-color: rgba(255, 255, 255, 0.1);
  color: var(--dp-muted, #94a3b8);
}

/* ==========================================================================
   SmartTTClub 4-Agent Theming System (Pingwi, Pingflo, Pingpro, Pingmynd)
   ========================================================================== */

/* Pingwi: Amber Warmth & Spark */
.digiping-chat.agent-theme-pingwi,
.agent-theme-pingwi {
  --dp-primary: #FFA451;
  --dp-primary-dark: #C26315;
  --dp-primary-light: #FFB370;
  --dp-accent: #FF8008;
  --dp-primary-gradient: linear-gradient(135deg, #FFA451 0%, #EA580C 100%);
  --dp-glass: rgba(25, 20, 16, 0.94);
  --dp-glow: rgba(255, 164, 81, 0.35);
}

/* Pingflo: Oceanic Flow & Active Cyan */
.digiping-chat.agent-theme-pingflo,
.agent-theme-pingflo {
  --dp-primary: #2A9BB5;
  --dp-primary-dark: #166375;
  --dp-primary-light: #48B6CE;
  --dp-accent: #00D2FF;
  --dp-primary-gradient: linear-gradient(135deg, #2A9BB5 0%, #0284C7 100%);
  --dp-glass: rgba(14, 23, 30, 0.94);
  --dp-glow: rgba(42, 155, 181, 0.35);
}

/* Pingpro: High-Performance Midnight Navy & Laser Cobalt */
.digiping-chat.agent-theme-pingpro,
.agent-theme-pingpro {
  --dp-primary: #1E40AF;
  --dp-primary-dark: #0B1F33;
  --dp-primary-light: #3B82F6;
  --dp-accent: #3B82F6;
  --dp-primary-gradient: linear-gradient(135deg, #1E40AF 0%, #0F172A 100%);
  --dp-glass: rgba(11, 19, 36, 0.94);
  --dp-glow: rgba(59, 130, 246, 0.35);
}

/* Pingmynd: Zen Emerald, Sage & Cognitive Longevity */
.digiping-chat.agent-theme-pingmynd,
.agent-theme-pingmynd {
  --dp-primary: #0F7B6C;
  --dp-primary-dark: #064E3B;
  --dp-primary-light: #1FB39E;
  --dp-accent: #34D399;
  --dp-primary-gradient: linear-gradient(135deg, #0F7B6C 0%, #047857 100%);
  --dp-glass: rgba(13, 27, 24, 0.94);
  --dp-glow: rgba(15, 123, 108, 0.35);
}

/* Agent Badge Pill in Header */
.agent-badge-pill {
  display: inline-flex;
  align-items: center;
  gap: 0.28rem;
  padding: 0.15rem 0.5rem;
  border-radius: 9999px;
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.01em;
  background: color-mix(in srgb, var(--dp-accent) 16%, transparent);
  border: 1px solid color-mix(in srgb, var(--dp-accent) 32%, transparent);
  color: var(--dp-accent);
  margin-left: 0;
  vertical-align: middle;
  min-width: 0;
  max-width: 200px;
  flex-shrink: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.agent-badge-pill__emoji {
  flex-shrink: 0;
  font-size: 0.8rem;
  line-height: 1;
}

.agent-badge-pill__text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Dedicated Agent Flow Bar beneath Header */
.digiping-chat__agent-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.5rem 0.85rem;
  padding: 0.55rem 1.15rem;
  background: rgba(4, 9, 20, 0.55);
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  flex-shrink: 0;
}

/* Agent Team Switcher HUD */
.agent-team-hud {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  background: rgba(0, 0, 0, 0.4);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 9999px;
  padding: 0.2rem 0.35rem;
  flex-shrink: 0;
}

.agent-team-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  padding: 0.22rem 0.6rem;
  border-radius: 9999px;
  font-size: 0.73rem;
  font-weight: 600;
  cursor: pointer;
  border: 1px solid transparent;
  background: transparent;
  color: var(--dp-muted);
  transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
}

.agent-team-chip:hover {
  color: #fff;
  background: rgba(255, 255, 255, 0.08);
}

.agent-team-chip--active {
  background: color-mix(in srgb, var(--dp-accent) 22%, transparent);
  border-color: color-mix(in srgb, var(--dp-accent) 50%, transparent);
  color: #fff;
  box-shadow: 0 0 10px color-mix(in srgb, var(--dp-accent) 25%, transparent);
}

.agent-team-chip__dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  flex-shrink: 0;
}

/* Agent Mission Tagline */
.digiping-chat__agent-mission {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  font-size: 0.76rem;
  color: color-mix(in srgb, var(--dp-text) 84%, transparent);
  line-height: 1.35;
  margin: 0;
  max-width: none;
  flex: 1 1 220px;
  overflow: visible;
  text-overflow: unset;
  white-space: normal;
}

.digiping-chat__agent-mission-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  flex-shrink: 0;
}

.digiping-chat__agent-mission-text {
  font-weight: 500;
  letter-spacing: 0.01em;
}

@media (max-width: 680px) {
  .digiping-chat__header {
    padding: 0.55rem 0.75rem;
    gap: 0.35rem;
  }
  .digiping-chat__brand {
    gap: 0.45rem;
  }
  .digiping-chat__avatar--sm {
    width: 32px;
    height: 32px;
  }
  .digiping-chat__agent-label-row {
    gap: 0.3rem;
  }
  .digiping-chat__agent-label-row .digiping-chat__title {
    font-size: 0.88rem;
  }
  .agent-badge-pill {
    font-size: 0.68rem;
    padding: 0.12rem 0.42rem;
    max-width: 140px;
  }
  .digiping-chat__actions {
    gap: 0.12rem;
  }
  .digiping-chat__icon-btn {
    width: 30px;
    height: 30px;
    border-radius: 8px;
  }
  .digiping-chat__close-btn {
    width: 30px;
    height: 30px;
    margin-left: 0.15rem;
  }
  .digiping-chat__agent-bar {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    padding: 0.35rem 0.65rem;
    gap: 0.4rem;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
  }
  .digiping-chat__agent-bar::-webkit-scrollbar {
    display: none;
  }
  .digiping-chat__agent-bar .agent-team-hud {
    display: flex;
    flex-shrink: 0;
    gap: 0.25rem;
    padding: 0.15rem 0.25rem;
    width: auto;
  }
  .digiping-chat__agent-bar .agent-team-chip {
    padding: 0.22rem 0.45rem;
    font-size: 0.68rem;
    white-space: nowrap;
    flex: 0 0 auto;
  }
  .digiping-chat__agent-mission {
    display: none;
  }
}

/* Micro-animations and ambient glows */
.agent-mark {
  transition: transform 0.3s ease, filter 0.3s ease;
}

.digiping-chat__avatar:hover .agent-mark {
  transform: scale(1.08) rotate(4deg);
}

@keyframes agentFabPulse {
  0% {
    box-shadow: 0 12px 32px color-mix(in srgb, var(--dp-primary) 45%, transparent),
                0 0 0 0 color-mix(in srgb, var(--dp-accent) 40%, transparent);
  }
  70% {
    box-shadow: 0 12px 32px color-mix(in srgb, var(--dp-primary) 45%, transparent),
                0 0 0 12px color-mix(in srgb, var(--dp-accent) 0%, transparent);
  }
  100% {
    box-shadow: 0 12px 32px color-mix(in srgb, var(--dp-primary) 45%, transparent),
                0 0 0 0 color-mix(in srgb, var(--dp-accent) 0%, transparent);
  }
}

.digiping-chat__fab {
  animation: agentFabPulse 4s infinite cubic-bezier(0.4, 0, 0.6, 1);
}
`, "",{"version":3,"sources":["webpack://./src/components/AICoach/DigipingChat.css"],"names":[],"mappings":"AAAA,sEAAsE;;AAItE,8GAA8G;AAC9G;;EAEE,eAAe;EACf,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,SAAS;EACT,gBAAgB;EAChB,yBAAyB;EACzB,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;EAC3C,qDAAqD;EACrD,uDAAuD;EACvD,+CAA+C;EAC/C,iGAAiG;EACjG,gDAAgD;EAChD,kBAAkB;EAClB,mBAAmB;EACnB,kCAAkC;EAClC,sCAAsC;EACtC,iCAAiC;EACjC,4BAA4B;EAC5B,2BAA2B;EAC3B,yDAAyD;EACzD,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA,QAAQ;AACR;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,aAAa;EACb,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uEAAuE;EACvE;;;;;GAKC;EACD;;kEAEgE;EAChE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,UAAU;EACV,gFAAgF;AAClF;;AAEA;EACE,sBAAsB;EACtB;;kEAEgE;AAClE;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA,8CAA8C;AAC9C;EACE,eAAe;EACf,0BAA0B;EAC1B,OAAO;EACP,QAAQ;EACR,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;EACX,6BAA6B;EAC7B,iCAAiC;EACjC,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,wCAAwC;EACxC;;;;0EAIwE;EACxE,2DAA2D;EAC3D,0BAA0B;EAC1B,kCAAkC;EAClC;6BAC2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,SAAS;EACT,OAAO;EACP,QAAQ;EACR,yBAAyB;EACzB,iBAAiB;EACjB,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,6BAA6B;EAC7B,6CAA6C;EAC7C,aAAa;AACf;;AAEA;EACE,eAAe;EACf,SAAS;EACT,4BAA4B;EAC5B,kCAAkC;EAClC,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,SAAS;EACT,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gCAAgC;EAChC,2EAA2E;EAC3E,yCAAyC;EACzC,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE;IACE,MAAM;IACN,UAAU;IACV,qEAAqE;IACrE,uBAAuB;IACvB,6BAA6B;IAC7B,iCAAiC;EACnC;;EAEA;IACE,gBAAgB;IAChB,uCAAuC;IACvC,4CAA4C;EAC9C;AACF;;AAEA,sEAAsE;AACtE;EACE,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;;EAEE,WAAW;EACX,2BAA2B;EAC3B,aAAa;EACb,+BAA+B;AACjC;;AAEA,sFAAsF;AACtF;;;;EAIE,0BAA0B;EAC1B,6BAA6B;EAC7B,aAAa;EACb,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,2BAA2B;EAC3B,2BAA2B;EAC3B,mCAAmC;EACnC,uCAAuC;EACvC,wCAAwC;AAC1C;;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA,WAAW;AACX;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,6BAA6B;EAC7B,kDAAkD;EAClD,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ;;;;;GAKC;EACD,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uEAAuE;EACvE,4EAA4E;EAC5E,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,aAAa;AACf;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,2BAA2B;EAC3B,cAAc;EACd,aAAa;EACb,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,kCAAkC;EAClC,2CAA2C;EAC3C,mBAAmB;EACnB,4BAA4B;EAC5B,iDAAiD;EACjD,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,sBAAsB;EACtB,kDAAkD;EAClD,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;EACjC,4BAA4B;EAC5B,mBAAmB;EACnB,yBAAyB;EACzB,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,2CAA2C;EAC3C,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,gCAAgC;EAChC,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,4DAA4D,qDAAqD,EAAE;AACnH,4DAA4D,qDAAqD,EAAE;AACnH,4DAA4D,qDAAqD,EAAE;AACnH,4DAA4D,qDAAqD,EAAE;AACnH,4DAA4D,qDAAqD,EAAE;;AAEnH;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,iFAAiF;EACjF,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,gCAAgC;EAChC,cAAc;EACd,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,cAAc;AAChB;;AAEA;;EAEE,2EAA2E;EAC3E,4EAA4E;AAC9E;;AAEA;EACE,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;EAChC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,WAAW;EACX,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;EACpC,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,YAAY;AACZ;EACE,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,qBAAqB;EACrB,qDAAqD;AACvD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,sBAAsB;EACtB,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,iCAAiC;EACjC,gCAAgC;EAChC,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,sCAAsC;EACtC,iCAAiC;EACjC,qBAAqB;EACrB,0CAA0C;EAC1C,kFAAkF;AACpF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,uBAAuB;EACvB,oBAAoB;EACpB,2CAA2C;EAC3C,+BAA+B;EAC/B,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,wDAAwD;AAC1D;;AAEA;EACE,+BAA+B;EAC/B,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,2BAA2B;EAC3B,4BAA4B;EAC5B,kBAAkB;EAClB,qDAAqD;EACrD,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,UAAU,EAAE;AACpB;;AAEA,kDAAkD;AAClD;EACE,gBAAgB;AAClB;;AAEA;kCACkC,cAAc,EAAE;AAClD,2BAA2B,cAAc,EAAE;AAC3C,2BAA2B,cAAc,EAAE;AAC3C,2BAA2B,cAAc,EAAE;AAC3C,2BAA2B,cAAc,EAAE;AAC3C;EACE,oDAAoD;EACpD,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;AACpB;AACA,8BAA8B,cAAc,EAAE;AAC9C,iCAAiC,uBAAuB,EAAE;;AAE1D;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,wBAAwB;EACxB,mBAAmB;EACnB,iCAAiC;EACjC,2CAA2C;EAC3C,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;EACnB,sCAAsC;EACtC,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,4BAA4B;EAC5B,yEAAyE;AAC3E;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,aAAa;EACb,oBAAoB;EACpB,kBAAkB;EAClB,0EAA0E;EAC1E,gFAAgF;AAClF;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;;EAEE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,2BAA2B;EAC3B,kBAAkB;EAClB,qBAAqB;EACrB,2DAA2D;AAC7D;;AAEA,gDAAgD,uBAAuB,EAAE;AACzE,gDAAgD,uBAAuB,EAAE;;AAEzE;EACE,gBAAgB,mBAAmB,EAAE;EACrC,MAAM,mBAAmB,EAAE;AAC7B;;AAEA,kBAAkB;AAClB;EACE,cAAc;EACd,aAAa;EACb,eAAe;EACf,YAAY;EACZ,2BAA2B;EAC3B,gCAAgC;EAChC,+CAA+C;EAC/C,kCAAkC;EAClC,sEAAsE;AACxE;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,+CAA+C;EAC/C,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,4EAA4E;EAC5E,0EAA0E;AAC5E;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,eAAe;EACf,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,mDAAmD;EACnD,8BAA8B;EAC9B,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;EACpC,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,gBAAgB;EAChB,0CAA0C;EAC1C,qCAAqC;EACrC,qBAAqB;EACrB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,wBAAwB;EACxB,oBAAoB;EACpB,eAAe;EACf,8EAA8E;AAChF;;AAEA;EACE,kEAAkE;EAClE,mEAAmE;EACnE,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;AACxB;;AAEA,aAAa;AACb;EACE,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,+BAA+B;EAC/B,kCAAkC;EAClC,+CAA+C;EAC/C,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;EACd,oCAAoC;EACpC,2CAA2C;EAC3C,oBAAoB;EACpB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,YAAY;EACZ,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,uCAAuC;EACvC,6BAA6B;AAC/B;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,qBAAqB;EACrB,oBAAoB;EACpB,2EAA2E;EAC3E,eAAe;EACf,iBAAiB;EACjB,iCAAiC;EACjC,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,6BAA6B;EAC7B,gEAAgE;EAChE,4BAA4B;EAC5B,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,yFAAyF;AACzF;EACE,eAAe;EACf,qBAAqB;EACrB,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,sCAAsC;EACtC,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,2EAA2E;AAC7E;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,qCAAqC;EACrC,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,+FAA+F;AACjG;;AAEA;EACE,qCAAqC;EACrC,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE;;IAEE,cAAc;EAChB;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;EAC5B;AACF;AACA,iCAAiC;AACjC;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,MAAM;EACN,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA;;EAEE;;;;GAIC;AACH;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6CAA6C;EAC7C,iCAAiC;EACjC,+BAA+B;EAC/B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,eAAe;EACf,cAAc;EACd,uGAAuG;AACzG;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA,4CAA4C,qDAAqD,EAAE;AACnG,4CAA4C,qDAAqD,EAAE;AACnG,4CAA4C,qDAAqD,EAAE;AACnG,4CAA4C,qDAAqD,EAAE;AACnG,4CAA4C,qDAAqD,EAAE;;AAEnG;EACE,UAAU;EACV,UAAU;EACV,sBAAsB;EACtB,+BAA+B;EAC/B,mBAAmB;EACnB;;qEAEmE;EACnE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,4HAA4H;AAC9H;AACA;EACE,cAAc;EACd,4HAA4H;AAC9H;AACA;EACE,cAAc;EACd,4HAA4H;AAC9H;AACA;EACE,cAAc;EACd,4HAA4H;AAC9H;AACA;EACE,cAAc;EACd,4HAA4H;AAC9H;;AAEA;EACE,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,+BAA+B;EAC/B,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE;;qCAEmC;EACnC,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,2BAA2B;EAC3B,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,oCAAoC;EACpC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,mBAAmB;EACnB,oCAAoC;EACpC,0CAA0C;EAC1C,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;AAClB;;;AAGA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,WAAW,wEAAwE,EAAE;EACrF,MAAM,2EAA2E,EAAE;AACrF;;AAEA,6CAA6C;AAC7C;EACE,cAAc;EACd,gCAAgC;EAChC,kDAAkD;EAClD,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;EACpB,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,kDAAkD;EAClD,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,kDAAkD;EAClD,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,2CAA2C;EAC3C,kCAAkC;EAClC,cAAc;EACd,oBAAoB;EACpB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mCAAmC;EACnC,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,2CAA2C;EAC3C,kCAAkC;EAClC,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,mCAAmC;EACnC,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,2CAA2C;EAC3C,kCAAkC;EAClC,mBAAmB;EACnB,wBAAwB;EACxB,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;EACnB,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,sEAAsE;AACxE;;AAEA;EACE,4GAA4G;EAC5G;;;;GAIC;AACH;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,4DAA4D;EAC5D,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,qBAAqB;EACrB,kDAAkD;EAClD,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;EACnB,gFAAgF;EAChF,2EAA2E;EAC3E,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,iCAAiC;EACjC,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA,iEAAiE;AACjE;EACE,aAAa;EACb,QAAQ;EACR,6BAA6B;EAC7B,kDAAkD;EAClD,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,6BAA6B;EAC7B,oBAAoB;EACpB,wBAAwB;EACxB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,+BAA+B;EAC/B,qCAAqC;EACrC,eAAe;EACf,yEAAyE;AAC3E;;AAEA;EACE,WAAW;EACX,4EAA4E;EAC5E,2EAA2E;AAC7E;;AAEA,0EAA0E;AAC1E;EACE,cAAc;EACd,wBAAwB;EACxB,qCAAqC;EACrC,sCAAsC;EACtC,+BAA+B;AACjC;;AAEA;;+EAE+E;;AAE/E,iCAAiC;AACjC;;EAEE,qBAAqB;EACrB,0BAA0B;EAC1B,2BAA2B;EAC3B,oBAAoB;EACpB,wEAAwE;EACxE,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA,wCAAwC;AACxC;;EAEE,qBAAqB;EACrB,0BAA0B;EAC1B,2BAA2B;EAC3B,oBAAoB;EACpB,wEAAwE;EACxE,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA,2DAA2D;AAC3D;;EAEE,qBAAqB;EACrB,0BAA0B;EAC1B,2BAA2B;EAC3B,oBAAoB;EACpB,wEAAwE;EACxE,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA,sDAAsD;AACtD;;EAEE,qBAAqB;EACrB,0BAA0B;EAC1B,2BAA2B;EAC3B,oBAAoB;EACpB,wEAAwE;EACxE,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA,+BAA+B;AAC/B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,iEAAiE;EACjE,uEAAuE;EACvE,uBAAuB;EACvB,cAAc;EACd,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,mBAAmB;EACnB,wBAAwB;EACxB,gCAAgC;EAChC,kDAAkD;EAClD,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,8BAA8B;EAC9B,2CAA2C;EAC3C,qBAAqB;EACrB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,uBAAuB;EACvB,sBAAsB;EACtB,kDAAkD;AACpD;;AAEA;EACE,WAAW;EACX,qCAAqC;AACvC;;AAEA;EACE,iEAAiE;EACjE,mEAAmE;EACnE,WAAW;EACX,0EAA0E;AAC5E;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,0DAA0D;EAC1D,iBAAiB;EACjB,SAAS;EACT,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE;IACE,wBAAwB;IACxB,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,wBAAwB;IACxB,gBAAgB;EAClB;EACA;IACE,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,YAAY;IACZ,oBAAoB;EACtB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,2BAA2B;IAC3B,wBAAwB;IACxB,WAAW;IACX,gBAAgB;IAChB,iCAAiC;IACjC,qBAAqB;EACvB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,cAAc;IACd,YAAY;IACZ,wBAAwB;IACxB,WAAW;EACb;EACA;IACE,wBAAwB;IACxB,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,aAAa;EACf;AACF;;AAEA,uCAAuC;AACvC;EACE,iDAAiD;AACnD;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE;IACE;6EACyE;EAC3E;EACA;IACE;+EAC2E;EAC7E;EACA;IACE;4EACwE;EAC1E;AACF;;AAEA;EACE,iEAAiE;AACnE","sourcesContent":["/* Digiping floating coach chat — matches profiling chat look & feel */\n\n@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@400;500;600;700;800&display=swap');\n\n/* Immersive mode (same contract as live training) — loaded with Digiping so it works without /live-training */\nhtml.lt-immersive,\nhtml.lt-immersive body {\n  position: fixed;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  overflow: hidden;\n  overscroll-behavior: none;\n  -webkit-overflow-scrolling: touch;\n  touch-action: manipulation;\n}\n\nhtml.lt-immersive body {\n  background: #0b0f19;\n}\n\nhtml.digiping-chat-open .bottom-nav,\nhtml.lt-immersive.digiping-chat-open .bottom-nav {\n  display: none !important;\n  pointer-events: none;\n}\n\nhtml.digiping-chat-open .main-content-with-bottom-nav {\n  padding-bottom: 0 !important;\n}\n\n.digiping-chat {\n  --dp-bg: #0b0f19;\n  --dp-slate: #0f172a;\n  --dp-primary: var(--brand-primary, #0877bc);\n  --dp-primary-dark: var(--brand-primary-dark, #065a8f);\n  --dp-primary-light: var(--brand-primary-light, #0a8cd8);\n  --dp-secondary: var(--brand-secondary, #46528b);\n  --dp-primary-gradient: linear-gradient(135deg, var(--dp-primary) 0%, var(--dp-primary-dark) 100%);\n  --dp-accent: var(--brand-primary-light, #0a8cd8);\n  --dp-text: #f8fafc;\n  --dp-muted: #94a3b8;\n  --dp-glass: rgba(15, 23, 42, 0.92);\n  --dp-border: rgba(255, 255, 255, 0.08);\n  --wizard-accent: var(--dp-accent);\n  --wizard-text-muted: #94a3b8;\n  --wizard-text-main: #f8fafc;\n  font-family: 'Outfit', 'Inter', -apple-system, sans-serif;\n  color: var(--dp-text);\n  box-sizing: border-box;\n}\n\n.digiping-chat *,\n.digiping-chat *::before,\n.digiping-chat *::after {\n  box-sizing: border-box;\n}\n\n/* FAB */\n.digiping-chat__fab {\n  position: fixed;\n  bottom: 24px;\n  right: 24px;\n  z-index: 1300;\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  border: 2px solid color-mix(in srgb, var(--dp-accent) 45%, transparent);\n  background: radial-gradient(\n    circle at 30% 25%,\n    color-mix(in srgb, var(--dp-accent) 35%, transparent),\n    color-mix(in srgb, var(--dp-primary) 95%, transparent) 55%,\n    var(--dp-primary-dark)\n  );\n  box-shadow:\n    0 12px 32px color-mix(in srgb, var(--dp-primary) 45%, transparent),\n    0 0 24px color-mix(in srgb, var(--dp-accent) 20%, transparent);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  padding: 0;\n  transition: transform 0.25s cubic-bezier(0.25, 1, 0.5, 1), box-shadow 0.25s ease;\n}\n\n.digiping-chat__fab:hover {\n  transform: scale(1.06);\n  box-shadow:\n    0 16px 40px color-mix(in srgb, var(--dp-primary) 55%, transparent),\n    0 0 32px color-mix(in srgb, var(--dp-accent) 28%, transparent);\n}\n\n.digiping-chat__fab:active {\n  transform: scale(0.97);\n}\n\n.digiping-chat__fab-dot {\n  position: absolute;\n  top: 6px;\n  right: 6px;\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background: #ff4a5a;\n  border: 2px solid #0b0f19;\n}\n\n@media (max-width: 600px) {\n  .digiping-chat__fab {\n    bottom: 96px;\n  }\n}\n\n/* Full-viewport shell (live-training style) */\n.digiping-chat__shell {\n  position: fixed;\n  top: var(--dp-vv-top, 0px);\n  left: 0;\n  right: 0;\n  z-index: 1400;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  width: 100%;\n  height: var(--dp-vvh, 100dvh);\n  max-height: var(--dp-vvh, 100dvh);\n  max-width: none;\n  border: none;\n  border-radius: 0;\n  box-shadow: none;\n  background-color: rgba(11, 15, 25, 0.55);\n  background-image:\n    radial-gradient(at 0% 0%, color-mix(in srgb, var(--dp-primary) 15%, transparent) 0px, transparent 50%),\n    radial-gradient(at 100% 100%, color-mix(in srgb, var(--dp-accent) 8%, transparent) 0px, transparent 50%),\n    linear-gradient(rgba(255, 255, 255, 0.01) 1px, transparent 1px),\n    linear-gradient(90deg, rgba(255, 255, 255, 0.01) 1px, transparent 1px);\n  background-size: 100% 100%, 100% 100%, 30px 30px, 30px 30px;\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n  padding: env(safe-area-inset-top) env(safe-area-inset-right) env(safe-area-inset-bottom)\n    env(safe-area-inset-left);\n  animation: digipingFadeIn 0.3s ease both;\n}\n\n.digiping-chat__shell--fullscreen {\n  /* alias kept for markup compatibility */\n}\n\n.digiping-chat__shell--docked {\n  top: auto;\n  left: 0;\n  right: 0;\n  height: min(48dvh, 460px);\n  max-height: 48dvh;\n  background: transparent;\n  background-image: none;\n  backdrop-filter: none;\n  -webkit-backdrop-filter: none;\n  padding: 0 0 env(safe-area-inset-bottom, 0px);\n  z-index: 1350;\n}\n\n.digiping-chat__shell--docked .digiping-chat__panel {\n  max-width: none;\n  margin: 0;\n  border-radius: 18px 18px 0 0;\n  border: 1px solid var(--dp-border);\n  box-shadow: 0 -16px 48px rgba(0, 0, 0, 0.35);\n}\n\n.digiping-chat__planning-chip {\n  flex: 0 0 auto;\n  margin: 0;\n  padding: 6px 14px;\n  font-size: 12px;\n  font-weight: 650;\n  letter-spacing: -0.01em;\n  color: var(--dp-accent, #7dd3fc);\n  background: color-mix(in srgb, var(--dp-primary, #0877bc) 16%, transparent);\n  border-bottom: 1px solid var(--dp-border);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n@media (min-width: 900px) {\n  .digiping-chat__shell--docked {\n    top: 0;\n    left: auto;\n    /* Planning focus: wider reading column, still leaves board visible */\n    width: min(640px, 52vw);\n    height: var(--dp-vvh, 100dvh);\n    max-height: var(--dp-vvh, 100dvh);\n  }\n\n  .digiping-chat__shell--docked .digiping-chat__panel {\n    border-radius: 0;\n    border-left: 1px solid var(--dp-border);\n    box-shadow: -12px 0 40px rgba(0, 0, 0, 0.28);\n  }\n}\n\n/* Planning mode: compact quick answers, more history, wider bubbles */\n.digiping-chat__shell--planning .digiping-chat__profiling-tray {\n  padding: 0.45rem 0.85rem 0.3rem;\n  max-height: min(32vh, 240px);\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n.digiping-chat__shell--planning .digiping-chat__profiling-tray-title {\n  margin: 0 0 0.4rem;\n  font-size: 0.7rem;\n  letter-spacing: 0.06em;\n}\n\n.digiping-chat__shell--planning .digiping-chat__profiling-options {\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  gap: 0.35rem;\n}\n\n.digiping-chat__shell--planning .digiping-chat__profiling-option {\n  flex: 0 0 auto;\n  width: 100%;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: flex-start;\n  text-align: left;\n  gap: 0.55rem;\n  border-radius: 10px;\n  padding: 0.45rem 0.7rem;\n}\n\n.digiping-chat__shell--planning .digiping-chat__profiling-option:hover:not(:disabled) {\n  transform: none;\n  box-shadow: none;\n}\n\n.digiping-chat__shell--planning .digiping-chat__profiling-option-title {\n  font-size: 0.84rem;\n  font-weight: 600;\n  line-height: 1.3;\n}\n\n.digiping-chat__shell--planning .digiping-chat__profiling-option-desc {\n  font-size: 0.75rem;\n  line-height: 1.3;\n  opacity: 0.78;\n}\n\n.digiping-chat__shell--planning .digiping-chat__quick {\n  gap: 0.35rem;\n  padding: 0.4rem 0.85rem 0.55rem;\n}\n\n.digiping-chat__shell--planning .digiping-chat__chip {\n  padding: 0.35rem 0.65rem;\n  font-size: 0.78rem;\n}\n\n.digiping-chat__shell--planning .digiping-chat__ai-bubble,\n.digiping-chat__shell--planning .digiping-chat__user-bubble {\n  max-width: min(100%, 36rem);\n}\n\n.digiping-chat__shell--planning .digiping-chat__history {\n  padding-left: 0.85rem;\n  padding-right: 0.85rem;\n}\n\n.digiping-chat__shell--planning .digiping-chat__msg-text {\n  font-size: 0.92rem;\n  line-height: 1.4;\n}\n\n@keyframes digipingFadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\nhtml:fullscreen .digiping-chat__shell,\nhtml:-webkit-full-screen .digiping-chat__shell {\n  width: 100%;\n  height: var(--dp-vvh, 100%);\n  min-height: 0;\n  max-height: var(--dp-vvh, 100%);\n}\n\n/* Keyboard open: shell fills only the visible area, so the composer stays above it. */\nhtml.digiping-keyboard-open .digiping-chat__shell,\nbody.digiping-keyboard-open .digiping-chat__shell,\nhtml.digiping-keyboard-open:fullscreen .digiping-chat__shell,\nhtml:-webkit-full-screen.digiping-keyboard-open .digiping-chat__shell {\n  top: var(--dp-vv-top, 0px);\n  height: var(--dp-vvh, 100dvh);\n  min-height: 0;\n  max-height: var(--dp-vvh, 100dvh);\n  padding-bottom: 0;\n}\n\n.digiping-chat__panel {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  min-height: 0;\n  max-width: 760px;\n  margin: 0 auto;\n  overflow: hidden;\n  background: var(--dp-glass);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  border-left: 1px solid var(--dp-border);\n  border-right: 1px solid var(--dp-border);\n}\n\n@media (max-width: 760px) {\n  .digiping-chat__panel {\n    max-width: none;\n    border-left: none;\n    border-right: none;\n  }\n}\n\n/* Header */\n.digiping-chat__header {\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  padding: 1rem 1.15rem 0.85rem;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n  background: rgba(8, 15, 28, 0.55);\n}\n\n.digiping-chat__brand {\n  display: flex;\n  align-items: center;\n  gap: 0.65rem;\n  min-width: 0;\n  flex: 1 1 auto;\n  overflow: hidden;\n}\n\n.digiping-chat__avatar {\n  width: 38px;\n  height: 38px;\n  background: radial-gradient(\n    circle at 30% 25%,\n    color-mix(in srgb, var(--dp-accent) 28%, transparent),\n    color-mix(in srgb, var(--dp-primary) 45%, transparent) 60%,\n    var(--dp-primary-dark)\n  );\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid color-mix(in srgb, var(--dp-accent) 35%, transparent);\n  box-shadow: 0 4px 14px color-mix(in srgb, var(--dp-accent) 18%, transparent);\n  flex-shrink: 0;\n  overflow: hidden;\n}\n\n.digiping-chat__avatar--sm {\n  width: 36px;\n  height: 36px;\n}\n\n.digiping-chat__avatar img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 50%;\n  display: block;\n}\n\n.digiping-chat--embedded {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  min-height: 0;\n  z-index: auto;\n}\n\n.digiping-chat__panel--embedded {\n  max-width: none;\n  height: 100%;\n  min-height: 0;\n  border: none;\n  background: transparent;\n  backdrop-filter: none;\n  -webkit-backdrop-filter: none;\n}\n\n.digiping-tech-intro {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  justify-content: flex-start;\n  flex: 1 1 auto;\n  min-height: 0;\n  padding: 0.65rem 0.85rem 0.85rem;\n  overflow: hidden;\n}\n\n.digiping-tech-intro__card {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  max-width: 640px;\n  min-height: 0;\n  max-height: 100%;\n  flex: 1 1 auto;\n  margin: 0 auto;\n  background: rgba(15, 23, 42, 0.82);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 24px;\n  padding: 1.15rem 1.2rem 1rem;\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.45);\n  overflow: hidden;\n}\n\n.digiping-tech-intro__header {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  flex: 0 0 auto;\n  margin-bottom: 0.85rem;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.05);\n  padding-bottom: 0.75rem;\n}\n\n.digiping-tech-intro__card .scforh-intro {\n  margin: 0 0 0.75rem;\n  flex: 0 0 auto;\n}\n\n.digiping-tech-intro__card .intro-body-text {\n  flex: 0 0 auto;\n  margin-bottom: 0.65rem;\n}\n\n.digiping-tech-intro__scroll .intro-body-text {\n  margin-top: 0;\n}\n\n.digiping-tech-intro__scroll {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  overflow-x: hidden;\n  -webkit-overflow-scrolling: touch;\n  overscroll-behavior: contain;\n  touch-action: pan-y;\n  margin: 0.15rem 0 0.75rem;\n  padding: 0.15rem 0.2rem 0.5rem;\n  border-radius: 14px;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(255, 255, 255, 0.22) transparent;\n}\n\n.digiping-tech-intro__scroll::-webkit-scrollbar {\n  width: 6px;\n}\n\n.digiping-tech-intro__scroll::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.2);\n  border-radius: 999px;\n}\n\n.digiping-tech-intro__card .who-capsule {\n  margin: 0 0 0.85rem;\n}\n\n.digiping-tech-intro__card .digiping-scforh-expand {\n  margin: 0.75rem 0 0;\n  border-radius: 12px;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  background: rgba(15, 23, 42, 0.35);\n  overflow: hidden;\n}\n\n.digiping-tech-intro__card .digiping-scforh-expand > summary {\n  list-style: none;\n  cursor: pointer;\n  padding: 0.7rem 0.9rem;\n  font-size: 0.82rem;\n  font-weight: 700;\n  color: #f8fafc;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n}\n\n.digiping-tech-intro__card .digiping-scforh-expand > summary::-webkit-details-marker {\n  display: none;\n}\n\n.digiping-tech-intro__card .digiping-scforh-expand > summary::after {\n  content: \"▸\";\n  color: rgba(248, 250, 252, 0.65);\n  font-size: 0.75rem;\n  transition: transform 0.15s ease;\n}\n\n.digiping-tech-intro__card .digiping-scforh-expand[open] > summary::after {\n  transform: rotate(90deg);\n}\n\n.digiping-tech-intro__card .digiping-scforh-expand .who-capsule {\n  margin: 0;\n  padding: 0 0.75rem 0.85rem;\n}\n\n.digiping-tech-intro__card .digiping-scforh-expand .who-capsule__eyebrow {\n  display: none;\n}\n\n.digiping-tech-intro__card .smart-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 0.45rem;\n  margin: 0;\n}\n\n.digiping-tech-intro__card .smart-bullet {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.7rem;\n  padding: 0.55rem 0.7rem;\n  border-radius: 12px;\n  background: rgba(255, 255, 255, 0.03);\n  border: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.digiping-tech-intro__card .smart-letter {\n  flex-shrink: 0;\n  width: 1.75rem;\n  height: 1.75rem;\n  border-radius: 8px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 800;\n  font-size: 0.85rem;\n  color: #0b0f19;\n}\n\n.digiping-tech-intro__card .smart-bullet--s .smart-letter { background: linear-gradient(135deg, #22d3ee, #0891b2); }\n.digiping-tech-intro__card .smart-bullet--m .smart-letter { background: linear-gradient(135deg, #34d399, #059669); }\n.digiping-tech-intro__card .smart-bullet--a .smart-letter { background: linear-gradient(135deg, #fbbf24, #d97706); }\n.digiping-tech-intro__card .smart-bullet--r .smart-letter { background: linear-gradient(135deg, #fb7185, #e11d48); }\n.digiping-tech-intro__card .smart-bullet--t .smart-letter { background: linear-gradient(135deg, #a78bfa, #7c3aed); }\n\n.digiping-tech-intro__card .smart-bullet-copy {\n  display: flex;\n  flex-direction: column;\n  gap: 0.12rem;\n  min-width: 0;\n}\n\n.digiping-tech-intro__card .smart-label {\n  font-size: 0.86rem;\n  font-weight: 700;\n  color: #f1f5f9;\n}\n\n.digiping-tech-intro__card .smart-desc {\n  font-size: 0.78rem;\n  line-height: 1.4;\n  color: #94a3b8;\n}\n\n.digiping-tech-intro__card .wizard-begin-btn {\n  flex: 0 0 auto;\n  margin-top: auto;\n  width: 100%;\n  border: none;\n  border-radius: 12px;\n  padding: 0.8rem 1rem;\n  font-family: inherit;\n  font-weight: 700;\n  font-size: 0.95rem;\n  color: #fff;\n  background: var(--dp-primary-gradient, linear-gradient(135deg, #0877bc, #065a8f));\n  cursor: pointer;\n}\n\n.digiping-chat__brand-text {\n  display: flex;\n  flex-direction: column;\n  gap: 0.1rem;\n  min-width: 0;\n  flex: 1 1 auto;\n  overflow: hidden;\n}\n\n.digiping-chat__agent-label-row {\n  display: flex;\n  align-items: center;\n  gap: 0.38rem;\n  min-width: 0;\n  max-width: 100%;\n  flex-wrap: nowrap;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.digiping-chat__agent-label-row .digiping-chat__title {\n  flex-shrink: 0;\n  max-width: none;\n  margin: 0;\n  white-space: nowrap;\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: #fff;\n}\n\n.digiping-chat__label {\n  font-size: 0.72rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  color: var(--dp-accent);\n  display: block;\n  margin: 0;\n}\n\n.digiping-chat__title {\n  font-size: 0.95rem;\n  font-weight: 700;\n  letter-spacing: 0.01em;\n  color: rgba(255, 255, 255, 0.96);\n  display: block;\n  margin: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: min(70vw, 22rem);\n}\n\n.digiping-chat__tag {\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--dp-accent);\n  opacity: 0.85;\n}\n\n.digiping-chat__actions {\n  display: flex;\n  align-items: center;\n  gap: 0.15rem;\n  flex-shrink: 0;\n  position: relative;\n  z-index: 6;\n}\n\n.digiping-chat__actions .lang-shortcut--invite .lang-shortcut__btn {\n  background: rgba(255, 255, 255, 0.06);\n  border: 1px solid rgba(255, 255, 255, 0.14);\n  color: #f8fafc;\n}\n\n.digiping-chat__actions .lang-shortcut--invite .lang-shortcut__btn:hover,\n.digiping-chat__actions .lang-shortcut--invite .lang-shortcut__btn.is-open {\n  background: color-mix(in srgb, var(--dp-primary, #0877bc) 45%, transparent);\n  border-color: color-mix(in srgb, var(--dp-accent, #0a8cd8) 50%, transparent);\n}\n\n.digiping-chat__actions .lang-shortcut--invite .lang-shortcut__panel {\n  right: 0;\n  left: auto;\n}\n\n.digiping-chat__icon-btn {\n  width: 34px;\n  height: 34px;\n  border: none;\n  border-radius: 10px;\n  background: transparent;\n  color: rgba(255, 255, 255, 0.78);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background 0.2s ease, color 0.2s ease;\n}\n\n.digiping-chat__icon-btn:hover {\n  background: rgba(255, 255, 255, 0.08);\n  color: #fff;\n}\n\n.digiping-chat__close-btn {\n  background: rgba(255, 255, 255, 0.08);\n  border: 1px solid rgba(255, 255, 255, 0.14);\n  color: #fff;\n  margin-left: 0.25rem;\n  flex-shrink: 0;\n}\n\n.digiping-chat__close-btn:hover {\n  background: rgba(239, 68, 68, 0.24);\n  border-color: rgba(239, 68, 68, 0.5);\n  color: #fca5a5;\n  transform: scale(1.05);\n}\n\n.digiping-chat__close-btn:active {\n  transform: scale(0.96);\n}\n\n/* History */\n.digiping-chat__history {\n  flex: 1 1 auto;\n  min-height: 0;\n  padding: 1.5rem 1.5rem 1.25rem;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(255, 255, 255, 0.1) transparent;\n}\n\n.digiping-chat__history::-webkit-scrollbar {\n  width: 6px;\n}\n\n.digiping-chat__history::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 10px;\n}\n\n/* Rows & bubbles */\n.digiping-chat__ai-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.8rem;\n  align-self: flex-start;\n  max-width: 88%;\n  animation: digipingMsgIn 0.45s ease both;\n}\n\n.digiping-chat__user-row {\n  align-self: flex-end;\n  max-width: 80%;\n  animation: digipingMsgIn 0.45s ease both;\n}\n\n@keyframes digipingMsgIn {\n  from { opacity: 0; transform: translateY(10px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n.digiping-chat__ai-bubble {\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.05);\n  border-radius: 4px 18px 18px 18px;\n  padding: 0.95rem 1.15rem 1.05rem;\n  position: relative;\n  min-width: 0;\n}\n\n.digiping-chat__user-bubble {\n  background: var(--dp-primary-gradient);\n  border-radius: 18px 18px 4px 18px;\n  padding: 1rem 1.25rem;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  box-shadow: 0 8px 16px -4px color-mix(in srgb, var(--dp-primary) 30%, transparent);\n}\n\n.digiping-chat__coach-label-row {\n  display: flex;\n  align-items: center;\n  gap: 0.45rem;\n  margin-bottom: 0.4rem;\n}\n\n.digiping-chat__msg-text {\n  font-size: 1.02rem;\n  line-height: 1.5;\n  margin: 0;\n  white-space: pre-wrap;\n  color: var(--dp-text);\n}\n\n.digiping-chat__user-bubble .digiping-chat__msg-text {\n  color: #fff;\n  font-weight: 500;\n}\n\n.digiping-chat__user-answer-row {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 0.45rem;\n}\n\n.digiping-chat__edit-answer-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n  margin: 0;\n  padding: 0.2rem 0.55rem;\n  border-radius: 999px;\n  border: 1px solid rgba(255, 255, 255, 0.28);\n  background: rgba(0, 0, 0, 0.18);\n  color: rgba(255, 255, 255, 0.92);\n  font-size: 0.72rem;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  cursor: pointer;\n  transition: background 0.2s ease, border-color 0.2s ease;\n}\n\n.digiping-chat__edit-answer-btn:hover {\n  background: rgba(0, 0, 0, 0.32);\n  border-color: rgba(255, 255, 255, 0.45);\n}\n\n.digiping-chat__profiling-editing-hint {\n  margin: 0 0 0.65rem;\n  text-align: center;\n  font-size: 0.88rem;\n  font-weight: 600;\n  color: var(--dp-accent, #0877bc);\n}\n\n.digiping-chat__typewriter {\n  min-height: 1.5em;\n  margin: 0;\n  white-space: pre-wrap;\n  font-size: 0.98rem;\n  line-height: 1.55;\n  color: #e8eef7;\n}\n\n.digiping-chat .typewriter-caret {\n  display: inline-block;\n  width: 2px;\n  height: 1.05em;\n  margin-left: 2px;\n  vertical-align: text-bottom;\n  background: var(--dp-accent);\n  border-radius: 1px;\n  animation: digipingCaretBlink 0.85s step-end infinite;\n  font-size: 0;\n  color: transparent;\n}\n\n@keyframes digipingCaretBlink {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0; }\n}\n\n/* Rich text — clean sections, no leading colons */\n.digiping-chat .dp-em {\n  font-weight: 700;\n}\n\n.digiping-chat .dp-em--s,\n.digiping-chat .dp-em--specific { color: #22d3ee; }\n.digiping-chat .dp-em--m { color: #34d399; }\n.digiping-chat .dp-em--a { color: #fbbf24; }\n.digiping-chat .dp-em--r { color: #fb7185; }\n.digiping-chat .dp-em--t { color: #a78bfa; }\n.digiping-chat .dp-em--smart {\n  background: linear-gradient(90deg, #22d3ee, #a78bfa);\n  -webkit-background-clip: text;\n  background-clip: text;\n  color: transparent;\n}\n.digiping-chat .dp-em--goal { color: #38bdf8; }\n.digiping-chat .dp-em--default { color: var(--dp-accent); }\n\n.digiping-chat .dp-rich-text {\n  display: flex;\n  flex-direction: column;\n  gap: 0.55rem;\n  font-size: 0.98rem;\n  line-height: 1.55;\n  color: #e8eef7;\n  white-space: normal;\n}\n\n.digiping-chat .dp-rich-section {\n  display: flex;\n  flex-direction: column;\n  gap: 0.28rem;\n  padding-top: 0.15rem;\n}\n\n.digiping-chat .dp-rich-heading {\n  font-size: 0.72rem;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  line-height: 1.35;\n}\n\n.digiping-chat .dp-rich-p {\n  margin: 0;\n  color: #e2e8f0;\n}\n\n.digiping-chat .dp-rich-smartline {\n  margin: 0;\n  padding: 0.45rem 0.65rem;\n  border-radius: 10px;\n  background: rgba(8, 15, 28, 0.45);\n  border: 1px solid rgba(255, 255, 255, 0.06);\n  font-size: 0.82rem;\n  line-height: 1.45;\n  color: #94a3b8;\n}\n\n.digiping-chat .dp-rich-ul,\n.digiping-chat .dp-rich-ol {\n  list-style: none;\n  margin: 0.1rem 0 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n}\n\n.digiping-chat .dp-rich-ol--session-plan {\n  gap: 0.55rem;\n  margin: 0.35rem 0 0.55rem;\n}\n\n.digiping-chat .dp-rich-li {\n  display: grid;\n  grid-template-columns: 1.15rem 1fr;\n  gap: 0.45rem;\n  align-items: start;\n}\n\n.digiping-chat .dp-rich-li--exercise {\n  grid-template-columns: 1.7rem 1fr;\n  gap: 0.55rem;\n  padding: 0.55rem 0.65rem;\n  border-radius: 12px;\n  background: rgba(255, 255, 255, 0.035);\n  border: 1px solid rgba(255, 255, 255, 0.07);\n}\n\n.digiping-chat .dp-rich-dot {\n  width: 0.38rem;\n  height: 0.38rem;\n  margin-top: 0.55em;\n  border-radius: 50%;\n  background: var(--dp-accent);\n  box-shadow: 0 0 8px color-mix(in srgb, var(--dp-accent) 45%, transparent);\n}\n\n.digiping-chat .dp-rich-index {\n  font-size: 0.72rem;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  color: var(--dp-accent);\n  margin-top: 0.12rem;\n}\n\n.digiping-chat .dp-rich-li--exercise .dp-rich-index {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.55rem;\n  height: 1.55rem;\n  margin-top: 0;\n  border-radius: 999px;\n  font-size: 0.78rem;\n  background: color-mix(in srgb, var(--dp-accent, #0a8cd8) 18%, transparent);\n  border: 1px solid color-mix(in srgb, var(--dp-accent, #0a8cd8) 42%, transparent);\n}\n\n.digiping-chat .dp-rich-li-copy {\n  min-width: 0;\n}\n\n.digiping-chat .dp-rich-li-copy--exercise {\n  display: flex;\n  flex-direction: column;\n  gap: 0.18rem;\n}\n\n.digiping-chat .dp-rich-ex-title {\n  display: block;\n  font-size: 0.95rem;\n  font-weight: 650;\n  line-height: 1.35;\n  color: #f8fafc;\n}\n\n.digiping-chat .dp-rich-ex-meta {\n  display: block;\n  font-size: 0.78rem;\n  line-height: 1.35;\n  color: rgba(226, 232, 240, 0.72);\n}\n\n.digiping-chat .dp-rich-ex-note,\n.digiping-chat .dp-rich-line--sub {\n  display: block;\n  font-size: 0.8rem;\n  line-height: 1.35;\n  color: rgba(148, 163, 184, 0.95);\n}\n\n.digiping-chat .dp-rich-line {\n  display: block;\n}\n\n/* Typing */\n.digiping-chat__typing {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.8rem;\n  align-self: flex-start;\n  max-width: 88%;\n}\n\n.digiping-chat__typing-dots {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  height: 20px;\n  margin-top: 0.15rem;\n}\n\n.digiping-chat__typing-dots span {\n  width: 8px;\n  height: 8px;\n  background: var(--dp-muted);\n  border-radius: 50%;\n  display: inline-block;\n  animation: digipingBounceDot 1.4s infinite ease-in-out both;\n}\n\n.digiping-chat__typing-dots span:nth-child(1) { animation-delay: -0.32s; }\n.digiping-chat__typing-dots span:nth-child(2) { animation-delay: -0.16s; }\n\n@keyframes digipingBounceDot {\n  0%, 80%, 100% { transform: scale(0); }\n  40% { transform: scale(1); }\n}\n\n/* Quick actions */\n.digiping-chat__quick {\n  flex: 0 0 auto;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.55rem;\n  justify-content: flex-start;\n  padding: 0.65rem 1.15rem 0.85rem;\n  border-top: 1px solid rgba(255, 255, 255, 0.06);\n  background: rgba(10, 15, 28, 0.72);\n  animation: digipingSlideUp 0.4s cubic-bezier(0.34, 1.56, 0.64, 1) both;\n}\n\n.digiping-chat__profiling-tray {\n  flex: 0 0 auto;\n  padding: 0.85rem 1.15rem 0.45rem;\n  border-top: 1px solid rgba(255, 255, 255, 0.06);\n  background: rgba(10, 15, 28, 0.72);\n}\n\n.digiping-chat__profiling-tray-title {\n  margin: 0 0 0.7rem;\n  font-size: 0.78rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--dp-accent, #0a8cd8);\n}\n\n.digiping-chat__handoff-hint {\n  margin: 0 0 0.75rem;\n  font-size: 0.88rem;\n  line-height: 1.45;\n  color: rgba(255, 255, 255, 0.72);\n}\n\n.digiping-chat__handoff-cta {\n  flex: 1 1 100%;\n  border-color: color-mix(in srgb, var(--dp-accent, #0a8cd8) 45%, transparent);\n  background: color-mix(in srgb, var(--dp-accent, #0a8cd8) 16%, transparent);\n}\n\n.digiping-chat__profiling-options {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.65rem;\n}\n\n.digiping-chat__profiling-option {\n  flex: 1 1 150px;\n  min-width: 0;\n  max-width: 100%;\n  background: rgba(255, 255, 255, 0.03);\n  border: 1px solid rgba(255, 255, 255, 0.05);\n  border-radius: 16px;\n  padding: 1rem 0.95rem;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.45rem;\n  transition: all 0.25s cubic-bezier(0.25, 1, 0.5, 1);\n  color: var(--dp-text, #f8fafc);\n  font-family: inherit;\n  text-align: center;\n}\n\n.digiping-chat__profiling-option:hover:not(:disabled) {\n  background: rgba(8, 119, 188, 0.06);\n  border-color: rgba(8, 119, 188, 0.4);\n  transform: translateY(-3px);\n  box-shadow: 0 10px 20px -5px rgba(0, 0, 0, 0.4);\n}\n\n.digiping-chat__profiling-option:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.digiping-chat__profiling-option-title {\n  font-size: 0.95rem;\n  font-weight: 600;\n  line-height: 1.35;\n}\n\n@keyframes digipingSlideUp {\n  from { opacity: 0; transform: translateY(14px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n.digiping-chat__chip {\n  appearance: none;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  background: rgba(255, 255, 255, 0.04);\n  color: var(--dp-text);\n  font-family: inherit;\n  font-size: 0.78rem;\n  font-weight: 600;\n  letter-spacing: 0.01em;\n  padding: 0.45rem 0.75rem;\n  border-radius: 999px;\n  cursor: pointer;\n  transition: background 0.2s ease, border-color 0.2s ease, transform 0.15s ease;\n}\n\n.digiping-chat__chip:hover {\n  background: color-mix(in srgb, var(--dp-primary) 22%, transparent);\n  border-color: color-mix(in srgb, var(--dp-accent) 35%, transparent);\n  transform: translateY(-1px);\n}\n\n.digiping-chat__chip:active {\n  transform: scale(0.98);\n}\n\n/* Composer */\n.digiping-chat__footer {\n  flex: 0 0 auto;\n  position: relative;\n  z-index: 2;\n  padding: 0.85rem 1.15rem 1.1rem;\n  background: rgba(10, 15, 28, 0.92);\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n  box-shadow: 0 -12px 28px rgba(0, 0, 0, 0.35);\n}\n\n.digiping-chat__fixcode-hint {\n  margin: 0 0 0.45rem;\n  font-size: 0.75rem;\n  letter-spacing: 0.04em;\n  color: #d7fff8;\n  background: rgba(10, 143, 138, 0.28);\n  border: 1px solid rgba(167, 243, 232, 0.35);\n  border-radius: 999px;\n  padding: 0.28rem 0.7rem;\n  width: fit-content;\n}\n\n.digiping-chat__composer {\n  display: flex;\n  align-items: flex-end;\n  gap: 0.65rem;\n  background: rgba(255, 255, 255, 0.03);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 14px;\n  padding: 0.45rem 0.55rem 0.45rem 0.9rem;\n  scroll-margin-bottom: 1.25rem;\n}\n\n.digiping-chat__input {\n  flex: 1;\n  min-width: 0;\n  background: transparent;\n  border: none;\n  outline: none;\n  resize: none;\n  color: var(--dp-text);\n  font-family: inherit;\n  /* 16px keeps iOS from zooming the page and shoving the field off-screen. */\n  font-size: 16px;\n  line-height: 1.45;\n  min-height: calc(1.45em + 0.9rem);\n  max-height: 50vh;\n  max-height: 50dvh;\n  overflow-x: hidden;\n  overflow-y: hidden;\n  padding: 0.45rem 0;\n  transition: height 0.18s ease;\n  /* Prefer scrolling inside the field once it hits half-screen. */\n  overscroll-behavior: contain;\n  -webkit-overflow-scrolling: touch;\n}\n\n.digiping-chat__input--multiline {\n  overflow-y: auto;\n  padding-right: 0.15rem;\n}\n\n/* Long draft: text uses the full row, like a sent bubble. Mic and send sit underneath. */\n.digiping-chat__composer:has(.digiping-chat__input--multiline) {\n  flex-wrap: wrap;\n  align-items: flex-end;\n  padding: 1rem 1.25rem 0.45rem;\n  gap: 0.45rem 0.65rem;\n}\n\n.digiping-chat__composer:has(.digiping-chat__input--multiline) .digiping-chat__input {\n  order: -1;\n  flex: 1 0 100%;\n  width: 100%;\n  padding: 0;\n}\n\n.digiping-chat__composer:has(.digiping-chat__input--multiline) .digiping-chat__voice {\n  margin-left: auto;\n}\n\n.digiping-chat__input::placeholder {\n  color: var(--dp-muted);\n  opacity: 1;\n}\n\n.digiping-chat__send {\n  width: 38px;\n  height: 38px;\n  border: none;\n  border-radius: 10px;\n  background: var(--dp-primary-gradient);\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  flex-shrink: 0;\n  transition: transform 0.3s cubic-bezier(0.16, 1, 0.3, 1), opacity 0.2s ease;\n}\n\n.digiping-chat__attach {\n  width: 38px;\n  height: 38px;\n  border: none;\n  border-radius: 10px;\n  background: rgba(255, 255, 255, 0.06);\n  color: var(--dp-muted);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  flex-shrink: 0;\n  transform: rotate(-25deg);\n  transition: transform 0.3s cubic-bezier(0.16, 1, 0.3, 1), background 0.2s ease, color 0.2s ease;\n}\n\n.digiping-chat__attach:hover:not(:disabled) {\n  background: rgba(255, 255, 255, 0.12);\n  color: var(--dp-text);\n}\n\n.digiping-chat__attach:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.digiping-chat__send:hover:not(:disabled) {\n  transform: scale(1.05);\n  filter: brightness(1.08);\n}\n\n.digiping-chat__send:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.digiping-chat__voice {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n}\n\n@media (max-width: 640px) {\n  .digiping-chat__ai-row,\n  .digiping-chat__user-row {\n    max-width: 94%;\n  }\n\n  .digiping-chat__msg-text,\n  .digiping-chat .dp-rich-text {\n    font-size: 0.95rem;\n  }\n\n  .digiping-chat__history {\n    padding: 1rem 1rem 0.85rem;\n  }\n}\n/* Digiping SMART progress rail */\n.digiping-smart-rail {\n  display: flex;\n  flex-direction: column;\n  gap: 0.45rem;\n}\n\n.digiping-smart-rail__track {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0;\n  padding-bottom: 0.65rem;\n}\n\n.digiping-smart-rail__link {\n  flex: 1;\n  height: 2px;\n  margin: 0 0.2rem;\n  border-radius: 2px;\n  background: rgba(255, 255, 255, 0.08);\n  transition: background 0.3s ease;\n}\n\n.digiping-smart-rail__link--complete,\n.digiping-smart-rail__link--partial {\n  background: linear-gradient(\n    90deg,\n    color-mix(in srgb, var(--dp-secondary) 55%, transparent),\n    color-mix(in srgb, var(--dp-accent) 35%, transparent)\n  );\n}\n\n.digiping-smart-rail__node {\n  width: 2rem;\n  height: 2rem;\n  border-radius: 50%;\n  border: 1.5px solid rgba(255, 255, 255, 0.12);\n  background: rgba(15, 23, 42, 0.9);\n  color: var(--wizard-text-muted);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  cursor: default;\n  flex-shrink: 0;\n  transition: transform 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease, background 0.25s ease;\n}\n\n.digiping-smart-rail__node:disabled {\n  opacity: 1;\n}\n\n.digiping-smart-rail__node:not(:disabled) {\n  cursor: pointer;\n}\n\n.digiping-smart-rail__letter {\n  font-size: 0.75rem;\n  font-weight: 800;\n  letter-spacing: 0.02em;\n}\n\n.digiping-smart-rail__node.is-empty {\n  opacity: 0.55;\n}\n\n.digiping-smart-rail__node.is-partial {\n  animation: digipingPulse 1.6s ease-in-out infinite;\n}\n\n.digiping-smart-rail__node.is-complete {\n  color: #0b0f19;\n  border-color: transparent;\n}\n\n.digiping-smart-rail__node--s.is-complete { background: linear-gradient(135deg, #22d3ee, #0891b2); }\n.digiping-smart-rail__node--m.is-complete { background: linear-gradient(135deg, #34d399, #059669); }\n.digiping-smart-rail__node--a.is-complete { background: linear-gradient(135deg, #fbbf24, #d97706); }\n.digiping-smart-rail__node--r.is-complete { background: linear-gradient(135deg, #fb7185, #e11d48); }\n.digiping-smart-rail__node--t.is-complete { background: linear-gradient(135deg, #a78bfa, #7c3aed); }\n\n.digiping-smart-rail__node.is-active {\n  opacity: 1;\n  z-index: 2;\n  transform: scale(1.18);\n  outline: 2px solid currentColor;\n  outline-offset: 3px;\n  box-shadow:\n    0 0 0 4px color-mix(in srgb, var(--dp-accent) 35%, transparent),\n    0 10px 24px color-mix(in srgb, var(--dp-accent) 28%, transparent);\n  border-color: currentColor;\n}\n\n.digiping-smart-rail__node--s.is-active {\n  color: #0891b2;\n  box-shadow: 0 0 0 4px color-mix(in srgb, #22d3ee 45%, transparent), 0 10px 24px color-mix(in srgb, #22d3ee 32%, transparent);\n}\n.digiping-smart-rail__node--m.is-active {\n  color: #059669;\n  box-shadow: 0 0 0 4px color-mix(in srgb, #34d399 45%, transparent), 0 10px 24px color-mix(in srgb, #34d399 32%, transparent);\n}\n.digiping-smart-rail__node--a.is-active {\n  color: #d97706;\n  box-shadow: 0 0 0 4px color-mix(in srgb, #fbbf24 45%, transparent), 0 10px 24px color-mix(in srgb, #fbbf24 32%, transparent);\n}\n.digiping-smart-rail__node--r.is-active {\n  color: #e11d48;\n  box-shadow: 0 0 0 4px color-mix(in srgb, #fb7185 45%, transparent), 0 10px 24px color-mix(in srgb, #fb7185 32%, transparent);\n}\n.digiping-smart-rail__node--t.is-active {\n  color: #7c3aed;\n  box-shadow: 0 0 0 4px color-mix(in srgb, #a78bfa 45%, transparent), 0 10px 24px color-mix(in srgb, #a78bfa 32%, transparent);\n}\n\n.digiping-smart-rail__node.is-active.is-complete {\n  color: #0b0f19;\n  outline-color: rgba(255, 255, 255, 0.85);\n}\n\n.digiping-chat__composer--idle {\n  align-items: center;\n}\n\n.digiping-chat__composer-idle {\n  flex: 1;\n  min-width: 0;\n  background: transparent;\n  border: none;\n  outline: none;\n  color: var(--dp-muted, #94a3b8);\n  font-family: inherit;\n  font-size: 1.02rem;\n  line-height: 1.45;\n  text-align: left;\n  padding: 0.45rem 0;\n  cursor: text;\n}\n\n.digiping-smart-rail__node.is-coach-pending {\n  position: relative;\n  border-color: rgba(251, 191, 36, 0.75);\n}\n\n.digiping-smart-rail__node.is-coach-pending.is-active {\n  box-shadow:\n    0 0 0 3px rgba(251, 191, 36, 0.55),\n    0 0 18px rgba(251, 191, 36, 0.35);\n  border-color: rgba(251, 191, 36, 0.95);\n  transform: scale(1.12);\n}\n\n.digiping-smart-rail__coach {\n  position: absolute;\n  bottom: -0.55rem;\n  left: 50%;\n  transform: translateX(-50%);\n  font-size: 0.5rem;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  white-space: nowrap;\n  padding: 0.1rem 0.28rem;\n  border-radius: 4px;\n  background: rgba(251, 191, 36, 0.95);\n  color: #1a1408;\n  line-height: 1.1;\n}\n\n.digiping-smart-rail__caption {\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  text-align: center;\n}\n\n.digiping-coach-banner {\n  margin: 0.35rem 0 0.85rem;\n  padding: 0.65rem 0.8rem;\n  border-radius: 10px;\n  background: rgba(251, 191, 36, 0.12);\n  border: 1px solid rgba(251, 191, 36, 0.35);\n  color: var(--wizard-text-muted);\n  font-size: 0.88rem;\n  line-height: 1.4;\n}\n\n\n.digiping-coach-pill {\n  display: inline-block;\n  margin-left: 0.4rem;\n  padding: 0.08rem 0.35rem;\n  border-radius: 4px;\n  font-size: 0.62rem;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  vertical-align: middle;\n  background: rgba(251, 191, 36, 0.95);\n  color: #1a1408;\n}\n\n@keyframes digipingPulse {\n  0%, 100% { box-shadow: 0 0 0 0 color-mix(in srgb, var(--dp-accent) 0%, transparent); }\n  50% { box-shadow: 0 0 0 6px color-mix(in srgb, var(--dp-accent) 12%, transparent); }\n}\n\n/* Digiping SMART rail / coach inbox extras */\n.digiping-chat__smart-rail-wrap {\n  flex: 0 0 auto;\n  padding: 0.55rem 1.15rem 0.35rem;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n  background: rgba(8, 15, 28, 0.4);\n}\n\n.digiping-chat__smart-summary {\n  margin: 0 0 0.35rem;\n  font-size: 0.8rem;\n  color: var(--dp-muted, #94a3b8);\n  line-height: 1.35;\n}\n\n.digiping-chat .dimension-chip {\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  padding: 0.15rem 0.5rem;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.06);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.digiping-chat__coach-inbox {\n  flex: 0 0 auto;\n  max-height: 32vh;\n  overflow-y: auto;\n  padding: 0.65rem 1.15rem;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n  background: rgba(251, 191, 36, 0.06);\n}\n\n.digiping-chat__smart-roster {\n  flex: 0 0 auto;\n  max-height: 36vh;\n  overflow-y: auto;\n  padding: 0.65rem 1.15rem;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n  background: rgba(56, 189, 248, 0.05);\n}\n\n.digiping-chat__smart-roster-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.5rem;\n  margin-bottom: 0.35rem;\n}\n\n.digiping-chat__smart-roster-head .digiping-chat__coach-inbox-title {\n  color: #7dd3fc;\n  margin-bottom: 0;\n}\n\n.digiping-chat__smart-roster-loading {\n  font-size: 0.75rem;\n  color: #94a3b8;\n}\n\n.digiping-chat__smart-roster-filters {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.3rem;\n  margin-bottom: 0.45rem;\n}\n\n.digiping-chat__smart-roster-chip {\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  background: rgba(15, 23, 42, 0.45);\n  color: #cbd5e1;\n  border-radius: 999px;\n  padding: 0.2rem 0.55rem;\n  font-size: 0.7rem;\n  font-weight: 600;\n  cursor: pointer;\n  font-family: inherit;\n}\n\n.digiping-chat__smart-roster-chip.is-active {\n  background: rgba(56, 189, 248, 0.2);\n  border-color: rgba(125, 211, 252, 0.45);\n  color: #e0f2fe;\n}\n\n.digiping-chat__smart-roster-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n\n.digiping-chat__smart-roster-empty {\n  margin: 0;\n  font-size: 0.8rem;\n  color: #94a3b8;\n}\n\n.digiping-chat__smart-roster-row {\n  width: 100%;\n  display: grid;\n  grid-template-columns: 1fr auto auto;\n  align-items: center;\n  gap: 0.45rem;\n  text-align: left;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  background: rgba(15, 23, 42, 0.55);\n  border-radius: 12px;\n  padding: 0.5rem 0.6rem;\n  color: inherit;\n  cursor: pointer;\n  font-family: inherit;\n}\n\n.digiping-chat__smart-roster-row.is-selected {\n  border-color: rgba(125, 211, 252, 0.5);\n  background: rgba(14, 165, 233, 0.12);\n}\n\n.digiping-chat__smart-roster-copy {\n  display: flex;\n  flex-direction: column;\n  gap: 0.1rem;\n  min-width: 0;\n  font-size: 0.78rem;\n  color: #cbd5e1;\n}\n\n.digiping-chat__smart-roster-copy strong {\n  font-size: 0.85rem;\n  color: #f8fafc;\n}\n\n.digiping-chat__smart-roster-copy span {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.digiping-chat__smart-roster-groups {\n  color: #94a3b8 !important;\n  font-size: 0.7rem !important;\n}\n\n.digiping-chat__smart-roster-progress {\n  color: #7dd3fc !important;\n  font-size: 0.72rem !important;\n  font-weight: 600;\n}\n\n.digiping-chat__smart-roster-letters {\n  display: flex;\n  gap: 0.18rem;\n  flex-shrink: 0;\n}\n\n.digiping-chat__smart-letter {\n  width: 1.15rem;\n  height: 1.15rem;\n  border-radius: 4px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.62rem;\n  font-weight: 800;\n  background: rgba(255, 255, 255, 0.06);\n  color: #64748b;\n}\n\n.digiping-chat__smart-letter--complete {\n  background: rgba(34, 197, 94, 0.25);\n  color: #86efac;\n}\n\n.digiping-chat__smart-letter--partial {\n  background: rgba(251, 191, 36, 0.22);\n  color: #fde68a;\n}\n\n.digiping-chat__smart-letter--empty {\n  background: rgba(255, 255, 255, 0.05);\n  color: #64748b;\n}\n\n.digiping-chat__smart-letter.is-pending {\n  box-shadow: 0 0 0 1px rgba(251, 191, 36, 0.7);\n}\n\n.digiping-chat__smart-roster-badge {\n  min-width: 1.25rem;\n  height: 1.25rem;\n  padding: 0 0.35rem;\n  border-radius: 999px;\n  background: rgba(251, 191, 36, 0.9);\n  color: #0f172a;\n  font-size: 0.7rem;\n  font-weight: 800;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.digiping-chat__coach-inbox-title {\n  font-size: 0.72rem;\n  font-weight: 800;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: #fbbf24;\n  margin-bottom: 0.45rem;\n}\n\n.digiping-chat__coach-event {\n  margin-bottom: 0.45rem;\n}\n\n.digiping-chat__coach-event-main {\n  width: 100%;\n  display: flex;\n  align-items: flex-start;\n  gap: 0.55rem;\n  text-align: left;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  background: rgba(15, 23, 42, 0.55);\n  border-radius: 12px;\n  padding: 0.55rem 0.65rem;\n  color: inherit;\n  cursor: pointer;\n  font-family: inherit;\n}\n\n.digiping-chat__coach-event-copy {\n  display: flex;\n  flex-direction: column;\n  gap: 0.15rem;\n  min-width: 0;\n  font-size: 0.82rem;\n}\n\n.digiping-chat__coach-event-copy strong {\n  font-size: 0.85rem;\n}\n\n.digiping-chat__coach-review {\n  margin-top: 0.4rem;\n  padding: 0.55rem 0.65rem;\n  border-radius: 12px;\n  background: rgba(0, 0, 0, 0.25);\n  display: flex;\n  flex-direction: column;\n  gap: 0.45rem;\n}\n\n.digiping-chat__coach-review p {\n  margin: 0;\n  font-size: 0.85rem;\n  color: #cbd5e1;\n}\n\n.digiping-chat__coach-existing-note {\n  color: #93c5fd !important;\n  font-style: italic;\n}\n\n.digiping-chat__coach-review-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.35rem;\n}\n\n.digiping-chat__coach-hint {\n  margin: 0;\n  font-size: 0.72rem;\n  color: var(--dp-muted, #94a3b8);\n}\n\n.digiping-chat .animate-slide-up {\n  animation: digipingSlideUp 0.4s cubic-bezier(0.34, 1.56, 0.64, 1) both;\n}\n\n.fb-msg--digiping .fb-msg__bubble {\n  border: 1px solid color-mix(in srgb, var(--brand-primary-light, var(--dp-accent, #0a8cd8)) 35%, transparent);\n  background: linear-gradient(\n    135deg,\n    color-mix(in srgb, var(--brand-primary, var(--dp-primary, #0877bc)) 18%, transparent),\n    rgba(15, 23, 42, 0.9)\n  );\n}\n\n.fb-msg__digiping-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  font-size: 0.68rem;\n  font-weight: 800;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--brand-primary-light, var(--dp-accent, #0a8cd8));\n  margin-bottom: 0.35rem;\n}\n\n.digiping-chat__people-pane {\n  flex: 1 1 auto;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.digiping-chat__main-tabs {\n  flex-shrink: 0;\n}\n\n.digiping-chat__embedded-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.5rem;\n  padding: 0.45rem 1rem;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n  background: rgba(8, 15, 28, 0.35);\n  flex-shrink: 0;\n}\n\n.digiping-chat__coach-suggest {\n  margin: 0.5rem 0;\n  padding: 0.65rem 0.75rem;\n  border-radius: 12px;\n  border: 1px solid color-mix(in srgb, var(--dp-accent, #0a8cd8) 40%, transparent);\n  background: color-mix(in srgb, var(--dp-primary, #0877bc) 16%, transparent);\n  font-size: 0.82rem;\n  line-height: 1.4;\n}\n\n.digiping-chat__coach-suggest strong {\n  display: block;\n  margin-bottom: 0.25rem;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  font-size: 0.68rem;\n  color: var(--dp-accent, #0a8cd8);\n}\n\n.digiping-chat__coach-suggest p {\n  margin: 0 0 0.45rem;\n  color: var(--dp-muted, #94a3b8);\n}\n\n.digiping-chat__coach-paths {\n  list-style: none;\n  margin: 0.35rem 0 0.55rem;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n}\n\n.digiping-chat__coach-paths li {\n  display: flex;\n  flex-direction: column;\n  gap: 0.15rem;\n  padding: 0.4rem 0.5rem;\n  border-radius: 10px;\n  background: rgba(8, 15, 28, 0.35);\n  border: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.digiping-chat__coach-paths span {\n  font-size: 0.78rem;\n  font-weight: 700;\n  color: #e2e8f0;\n}\n\n.digiping-chat__coach-paths small {\n  font-size: 0.72rem;\n  line-height: 1.35;\n  color: var(--dp-muted, #94a3b8);\n}\n\n.digiping-chat__path-axis {\n  font-size: 0.62rem;\n  font-style: normal;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--dp-accent, #0a8cd8);\n}\n\n/* Home Digiping people/agent tabs (same look as Live Training) */\n.digiping-chat .dp-session-tabs {\n  display: flex;\n  gap: 6px;\n  padding: 0.55rem 1rem 0.65rem;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n  background: rgba(8, 15, 28, 0.4);\n  flex-shrink: 0;\n}\n\n.digiping-chat .dp-session-tabs__tab {\n  flex: 1;\n  border: 1px solid transparent;\n  border-radius: 999px;\n  padding: 0.55rem 0.75rem;\n  font-family: inherit;\n  font-size: 0.78rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--dp-muted, #94a3b8);\n  background: rgba(255, 255, 255, 0.04);\n  cursor: pointer;\n  transition: background 0.2s ease, color 0.2s ease, border-color 0.2s ease;\n}\n\n.digiping-chat .dp-session-tabs__tab--active {\n  color: #fff;\n  border-color: color-mix(in srgb, var(--dp-accent, #0a8cd8) 45%, transparent);\n  background: color-mix(in srgb, var(--dp-primary, #0877bc) 28%, transparent);\n}\n\n/* AI Act Art. 50 notice — must stay legible on the dark Digiping chrome */\n.digiping-chat__ai-notice {\n  flex: 0 0 auto;\n  margin: 0.5rem 1.15rem 0;\n  background: rgba(255, 255, 255, 0.05);\n  border-color: rgba(255, 255, 255, 0.1);\n  color: var(--dp-muted, #94a3b8);\n}\n\n/* ==========================================================================\n   SmartTTClub 4-Agent Theming System (Pingwi, Pingflo, Pingpro, Pingmynd)\n   ========================================================================== */\n\n/* Pingwi: Amber Warmth & Spark */\n.digiping-chat.agent-theme-pingwi,\n.agent-theme-pingwi {\n  --dp-primary: #FFA451;\n  --dp-primary-dark: #C26315;\n  --dp-primary-light: #FFB370;\n  --dp-accent: #FF8008;\n  --dp-primary-gradient: linear-gradient(135deg, #FFA451 0%, #EA580C 100%);\n  --dp-glass: rgba(25, 20, 16, 0.94);\n  --dp-glow: rgba(255, 164, 81, 0.35);\n}\n\n/* Pingflo: Oceanic Flow & Active Cyan */\n.digiping-chat.agent-theme-pingflo,\n.agent-theme-pingflo {\n  --dp-primary: #2A9BB5;\n  --dp-primary-dark: #166375;\n  --dp-primary-light: #48B6CE;\n  --dp-accent: #00D2FF;\n  --dp-primary-gradient: linear-gradient(135deg, #2A9BB5 0%, #0284C7 100%);\n  --dp-glass: rgba(14, 23, 30, 0.94);\n  --dp-glow: rgba(42, 155, 181, 0.35);\n}\n\n/* Pingpro: High-Performance Midnight Navy & Laser Cobalt */\n.digiping-chat.agent-theme-pingpro,\n.agent-theme-pingpro {\n  --dp-primary: #1E40AF;\n  --dp-primary-dark: #0B1F33;\n  --dp-primary-light: #3B82F6;\n  --dp-accent: #3B82F6;\n  --dp-primary-gradient: linear-gradient(135deg, #1E40AF 0%, #0F172A 100%);\n  --dp-glass: rgba(11, 19, 36, 0.94);\n  --dp-glow: rgba(59, 130, 246, 0.35);\n}\n\n/* Pingmynd: Zen Emerald, Sage & Cognitive Longevity */\n.digiping-chat.agent-theme-pingmynd,\n.agent-theme-pingmynd {\n  --dp-primary: #0F7B6C;\n  --dp-primary-dark: #064E3B;\n  --dp-primary-light: #1FB39E;\n  --dp-accent: #34D399;\n  --dp-primary-gradient: linear-gradient(135deg, #0F7B6C 0%, #047857 100%);\n  --dp-glass: rgba(13, 27, 24, 0.94);\n  --dp-glow: rgba(15, 123, 108, 0.35);\n}\n\n/* Agent Badge Pill in Header */\n.agent-badge-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.28rem;\n  padding: 0.15rem 0.5rem;\n  border-radius: 9999px;\n  font-size: 0.72rem;\n  font-weight: 600;\n  letter-spacing: 0.01em;\n  background: color-mix(in srgb, var(--dp-accent) 16%, transparent);\n  border: 1px solid color-mix(in srgb, var(--dp-accent) 32%, transparent);\n  color: var(--dp-accent);\n  margin-left: 0;\n  vertical-align: middle;\n  min-width: 0;\n  max-width: 200px;\n  flex-shrink: 1;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.agent-badge-pill__emoji {\n  flex-shrink: 0;\n  font-size: 0.8rem;\n  line-height: 1;\n}\n\n.agent-badge-pill__text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* Dedicated Agent Flow Bar beneath Header */\n.digiping-chat__agent-bar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 0.5rem 0.85rem;\n  padding: 0.55rem 1.15rem;\n  background: rgba(4, 9, 20, 0.55);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n  flex-shrink: 0;\n}\n\n/* Agent Team Switcher HUD */\n.agent-team-hud {\n  display: flex;\n  align-items: center;\n  gap: 0.35rem;\n  background: rgba(0, 0, 0, 0.4);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 9999px;\n  padding: 0.2rem 0.35rem;\n  flex-shrink: 0;\n}\n\n.agent-team-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.3rem;\n  padding: 0.22rem 0.6rem;\n  border-radius: 9999px;\n  font-size: 0.73rem;\n  font-weight: 600;\n  cursor: pointer;\n  border: 1px solid transparent;\n  background: transparent;\n  color: var(--dp-muted);\n  transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.agent-team-chip:hover {\n  color: #fff;\n  background: rgba(255, 255, 255, 0.08);\n}\n\n.agent-team-chip--active {\n  background: color-mix(in srgb, var(--dp-accent) 22%, transparent);\n  border-color: color-mix(in srgb, var(--dp-accent) 50%, transparent);\n  color: #fff;\n  box-shadow: 0 0 10px color-mix(in srgb, var(--dp-accent) 25%, transparent);\n}\n\n.agent-team-chip__dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n/* Agent Mission Tagline */\n.digiping-chat__agent-mission {\n  display: flex;\n  align-items: center;\n  gap: 0.45rem;\n  font-size: 0.76rem;\n  color: color-mix(in srgb, var(--dp-text) 84%, transparent);\n  line-height: 1.35;\n  margin: 0;\n  max-width: none;\n  flex: 1 1 220px;\n  overflow: visible;\n  text-overflow: unset;\n  white-space: normal;\n}\n\n.digiping-chat__agent-mission-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.digiping-chat__agent-mission-text {\n  font-weight: 500;\n  letter-spacing: 0.01em;\n}\n\n@media (max-width: 680px) {\n  .digiping-chat__header {\n    padding: 0.55rem 0.75rem;\n    gap: 0.35rem;\n  }\n  .digiping-chat__brand {\n    gap: 0.45rem;\n  }\n  .digiping-chat__avatar--sm {\n    width: 32px;\n    height: 32px;\n  }\n  .digiping-chat__agent-label-row {\n    gap: 0.3rem;\n  }\n  .digiping-chat__agent-label-row .digiping-chat__title {\n    font-size: 0.88rem;\n  }\n  .agent-badge-pill {\n    font-size: 0.68rem;\n    padding: 0.12rem 0.42rem;\n    max-width: 140px;\n  }\n  .digiping-chat__actions {\n    gap: 0.12rem;\n  }\n  .digiping-chat__icon-btn {\n    width: 30px;\n    height: 30px;\n    border-radius: 8px;\n  }\n  .digiping-chat__close-btn {\n    width: 30px;\n    height: 30px;\n    margin-left: 0.15rem;\n  }\n  .digiping-chat__agent-bar {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: flex-start;\n    padding: 0.35rem 0.65rem;\n    gap: 0.4rem;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n    scrollbar-width: none;\n  }\n  .digiping-chat__agent-bar::-webkit-scrollbar {\n    display: none;\n  }\n  .digiping-chat__agent-bar .agent-team-hud {\n    display: flex;\n    flex-shrink: 0;\n    gap: 0.25rem;\n    padding: 0.15rem 0.25rem;\n    width: auto;\n  }\n  .digiping-chat__agent-bar .agent-team-chip {\n    padding: 0.22rem 0.45rem;\n    font-size: 0.68rem;\n    white-space: nowrap;\n    flex: 0 0 auto;\n  }\n  .digiping-chat__agent-mission {\n    display: none;\n  }\n}\n\n/* Micro-animations and ambient glows */\n.agent-mark {\n  transition: transform 0.3s ease, filter 0.3s ease;\n}\n\n.digiping-chat__avatar:hover .agent-mark {\n  transform: scale(1.08) rotate(4deg);\n}\n\n@keyframes agentFabPulse {\n  0% {\n    box-shadow: 0 12px 32px color-mix(in srgb, var(--dp-primary) 45%, transparent),\n                0 0 0 0 color-mix(in srgb, var(--dp-accent) 40%, transparent);\n  }\n  70% {\n    box-shadow: 0 12px 32px color-mix(in srgb, var(--dp-primary) 45%, transparent),\n                0 0 0 12px color-mix(in srgb, var(--dp-accent) 0%, transparent);\n  }\n  100% {\n    box-shadow: 0 12px 32px color-mix(in srgb, var(--dp-primary) 45%, transparent),\n                0 0 0 0 color-mix(in srgb, var(--dp-accent) 0%, transparent);\n  }\n}\n\n.digiping-chat__fab {\n  animation: agentFabPulse 4s infinite cubic-bezier(0.4, 0, 0.6, 1);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
